import $ from "jquery";
import FilePreviewComponent from "@/components/FilePreviewComponent/FilePreviewComponent.vue";
import Navbar from '@/components/Home_Navbar/NavbarView.vue';
import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import { get_token, get_drive_id, is_demo_domain } from '@/router/index.js';
import { Modal } from "bootstrap";
import Swal from 'sweetalert2';

const DRIVE_SECTION_LABELS = new Map([
  ["shared", "Files and folders shared with you"],
  ["recent", "Recently opened and updated items"],
  ["starred", "Files and folders you starred"],
  ["trash", "Deleted files and folders"],
]);

const DRIVE_SECTION_ENDPOINTS = new Map([
  ["my", "get_my_drive_items"],
  ["shared", "get_shared_items"],
  ["recent", "get_recent_items"],
  ["starred", "get_starred_items"],
  ["trash", "get_trash_items"],
  ["admin",  "get_all_drives"],
]);
const COPY_FILE_URL = '/aic_one_api/aic_drive/copy_file/';
const RESPONSE_DRIVE_ITEM_KEYS = Object.freeze(["drive_item", "item", "file", "folder"]);
const LOCAL_DRIVE_ITEM_KEYS = Object.freeze([
  "id", "drive_id", "name", "type", "item_type", "size", "file_size", "size_bytes",
  "mime_type", "content_type", "file_type", "extension", "path", "location", "folder_path",
  "parent_folder", "parent_name", "parent_id", "parent_folder_id", "parent_item_id",
  "owner", "owner_name", "drive_owner", "drive_owner_name", "owner_email", "owner_id",
  "drive_owner_id", "drive_owner_email", "created_by", "created_by_name", "creator",
  "created_by_email", "created_by_id", "shared_by", "shared_by_name", "shared_by_email",
  "shared_by_id", "shared_access_level", "is_starred", "starred", "is_trashed",
  "trashed", "is_deleted", "deleted_at", "last_opened_by", "opened_by", "created_at",
  "modified_at", "updated_at", "activity_at", "last_opened_at", "created_at_raw",
  "modified_at_raw", "updated_at_raw", "activity_at_raw", "last_opened_at_raw",
  "can_manage", "can_delete",
]);

const parse_stored_user = () => {
  return JSON.parse(localStorage.getItem("user") || "{}");
};

export default {
  name: 'DriveView',
  components: { Sidebar, Navbar, FilePreviewComponent},
  data: () => ({
    view_mode: 'grid',
    cmd_query: '',
    hovered_file: null,
    hover_timer: null,

    dataTable: null,
    uploads: [],
    drive_items: [],
    storage_stats: {
      used_gb: 0,
      total_gb: 0,
      available_gb: 0,
      percentage_used: 0,
    },
    storage_loading: false,
    drive_items_loading: false,
    active_tab: 'folder',
    current_folder: "My Drive",
    current_folder_id: null,
    current_drive_id: null,
    open_dropdown_id: null,
    open_submenu_id: null,
    open_menu_name: null,
    preview_file_name: "",
    preview_file_url: "",
    preview_file_access_level: null,
    preview_modal: false,
    share_link: "",
    share_file: null,
    access_levels: [],
    share_mode: 'restricted',
    selected_access_level: '',
    drive_id: null,
    share_success: false,
    available_users: [],
    filtered_available_users: [],
    selected_share_users: [],
    user_search_query: '',
    loading_users: false,
    users_error: null,
    sharing_in_progress: false,
    share_error: null,
    user_access_level: '',

    shared_with_list: [],
    loading_shared_with: false,
    revoking_user_id: null,

    // UI filters
    list_search_query: "",
    fileTypeFilter: "all",
    drive_section: "my",
    route_drive_item_opened: false,
    route_share_token_resolving: false,
    starred_item_ids: [],
    mobile_sort_menu_open: false,
    sort_by: "newest",

    // misc
    drag_over: false,
    submenu_open: {},
    selected_url: null,
    uploading_in_progress: false,

    // Drag and drop
    dragged_item: null,
    drag_over_folder_id: null,
    page_drag_active: false,

    create_doc_kind: null,
    new_doc_title: "",
    new_folder_name: "",
    drive_refresh_debounce_id: null,
    drive_was_hidden: false,
    _drive_visibility_handler: null,
    _drive_focus_handler: null,

    // Libre Office
    office_editor_url: null,
    office_file_name: '',
    office_loading: false,
    editor_open_locks: {},

    open_mobile_action_id: null,
    mobile_new_menu_open: false,
    mobile_new_menu_style: {},
    mobile_drive_drawer_open: false,
    copied_file: null,
    breadcrumb_overflow_open: false,
    mobile_action_position: {
      directionY: 'down',
      directionX: 'right',
    },

    rename_item: null,
    rename_new_name: "",
    rename_in_progress: false,
    delete_item: null,
    delete_in_progress: false,
    empty_trash_in_progress: false,

    portal_file: null,
    portal_style: {},
    selected_preview_file: null,
    details_file: null,
    details_shared_with_list: [],
    details_loading_shared_with: false,
    // Admin — All Drives
    admin_drives: [],
    admin_drives_loading: false,
    admin_selected_drive: null,
    // Transfer ownership
    transfer_item: null,
    transfer_target_user_id: null,
    transfer_user_query: '',
    filtered_transfer_users: [],
    transfer_in_progress: false,
  }),

  computed: {
    can_view_all_drives() {
      const user = parse_stored_user();
      const role = (user?.role_name || user?.role || "").toLowerCase().replace(/\s+/g, "_");
      return [
        "system_admin",
        "superadmin",
        "super_admin",
        "organization_admin",
        "org_admin",
      ].includes(role);
    },

    admin_drives_count() {
      return this.admin_drives.length || null;
    },

    admin_active_drives_count() {
      return this.admin_drives.filter((drive) => this.admin_visible_item_count(drive) > 0).length;
    },

    admin_total_items_count() {
      return this.admin_drives.reduce((total, drive) => total + this.admin_visible_item_count(drive), 0);
    },

    admin_filtered_drives() {
      const q = (this.list_search_query || "").toLowerCase().trim();
      if (!q) return this.admin_drives;

      return this.admin_drives.filter((drive) => {
        return [drive.name, drive.owner, drive.email]
          .filter(Boolean)
          .some((value) => String(value).toLowerCase().includes(q));
      });
    },

    cmd_filtered_items() {
      const q = (this.cmd_query || '').toLowerCase().trim();
      const items = this.drive_items.filter(i => i.type !== 'folder');
      if (!q) return items.slice(0, 5);
      return items.filter(i => i.name.toLowerCase().includes(q)).slice(0, 6);
    },

    breadcrumb_path() {
      const path = [];
      let folder_id = this.current_folder_id;
      let folder_name = this.current_folder;
      let drive_id    = this.current_drive_id;
      const section_items = this.section_items;

      while (folder_id || (folder_name && folder_name !== this.root_label)) {
        const folder = folder_id
          ? section_items.find((i) => i.type === "folder" && String(i.id) === String(folder_id))
          : section_items.find(
            (i) => i.type === "folder" && i.name === folder_name && i.drive_id === drive_id
          );
        if (!folder) break;
        path.unshift(folder);
        folder_id = folder.parent_folder_id || null;
        folder_name = folder.parent_id === this.root_label || folder.parent_id === "My Drive" ? null : folder.parent_id;
        drive_id = folder.drive_id;
      }
      return path;
    },

    visible_breadcrumb_path() {
      return this.breadcrumb_path.length > 3
        ? this.breadcrumb_path.slice(-3)
        : this.breadcrumb_path;
    },

    hidden_breadcrumb_path() {
      return this.breadcrumb_path.length > 3
        ? this.breadcrumb_path.slice(0, -3)
        : [];
    },

    hidden_breadcrumb_label() {
      return this.hidden_breadcrumb_path.map((folder) => folder.name).join(" / ");
    },

    root_label() {
      const labels = {
        admin: "All Drives",
        my: "My Drive",
        shared: "Shared with me",
        recent: "Recent",
        starred: "Starred",
        trash: "Trash",
      };
      return labels[this.drive_section] || "My Drive";
    },

    mobile_drive_title() {
      if (this.drive_section === "admin") {
        if (this.admin_selected_drive) return this.current_folder_id ? this.current_folder : this.admin_selected_drive.name;
        return "All Drives";
      }
      return this.current_folder_id ? this.current_folder : this.root_label;
    },

    owned_items() {
      return this.drive_items.filter((item) => !this.is_shared_item(item) && !this.is_trashed_item(item));
    },

    shared_items() {
      return this.drive_items.filter((item) => this.is_shared_item(item) && !this.is_trashed_item(item));
    },

    recent_items() {
      return [...this.drive_items]
        .filter((item) => !this.is_trashed_item(item))
        .sort((a, b) => Number(b.updated_ts || 0) - Number(a.updated_ts || 0));
    },

    starred_items() {
      return this.drive_items.filter((item) => this.is_starred_item(item) && !this.is_trashed_item(item));
    },

    trash_items() {
      return this.drive_items.filter((item) => this.is_trashed_item(item));
    },

    section_items() {
      if (this.drive_section === "admin")   return this.drive_items;
      if (this.drive_section === "shared") return this.drive_items.filter((item) => !this.is_trashed_item(item));
      if (this.drive_section === "recent") return this.recent_items;
      if (this.drive_section === "starred") return this.drive_items.filter((item) => !this.is_trashed_item(item));
      if (this.drive_section === "trash") return this.drive_items;
      return this.owned_items;
    },

    // Cards at the top (4 most recent files on desktop and 2 on mobile)
    for_you_items() {
      if (this.drive_section === "admin" && !this.admin_selected_drive) return [];
      const items = this.section_items
        .filter((i) => i.type !== "folder")
        .sort((a, b) => {
          const a_time = a.updated_ts || new Date(a.updated_at).getTime();
          const b_time = b.updated_ts || new Date(b.updated_at).getTime();
          return b_time - a_time;
        });

      return window.innerWidth <= 575 ? items.slice(0, 2) : items.slice(0, 4);
    },

    filtered_items() {
      const section_items = this.section_items;
      const in_folder = this.current_folder_id === null && this.drive_section !== "my" && this.drive_section !== "shared"
        ? this.top_level_items_for(section_items)
        : section_items.filter((i) => {
          if (this.current_folder_id !== null) {
            return this.is_child_of_current_folder(i);
          }

          return this.is_top_level_item(i, section_items);
      });



      const q = (this.list_search_query || "").toLowerCase().trim();
      const by_query = !q
        ? in_folder
        : in_folder.filter(
            (i) =>
              i.name.toLowerCase().includes(q) ||
              (i.owner || "").toLowerCase().includes(q) ||
              (i.created_by || "").toLowerCase().includes(q)
          );

      const type = this.fileTypeFilter;
      if (type === "all") return this.sort_filtered_items(by_query);

      return this.sort_filtered_items(by_query.filter((i) => this.matches_chip(i, type)));
    },

    chip_options() {
      return [
        { value: "all", label: "All", icon: "far fa-circle" },
        { value: "word", label: "Word", icon: "far fa-file-word" },
        { value: "excel", label: "Excel", icon: "far fa-file-excel" },
        { value: "ppt", label: "PowerPoint", icon: "far fa-file-powerpoint" },
        { value: "pdf", label: "PDF", icon: "far fa-file-pdf" },
        { value: "image", label: "Images", icon: "far fa-file-image" },
        { value: "video", label: "Videos", icon: "far fa-file-video" },
      ];
    },

    sort_options() {
      return [
        { value: "newest", label: "Newest first", icon: "fas fa-arrow-down-wide-short" },
        { value: "oldest", label: "Oldest first", icon: "fas fa-arrow-up-wide-short" },
        { value: "name_asc", label: "Name A-Z", icon: "fas fa-arrow-down-a-z" },
        { value: "name_desc", label: "Name Z-A", icon: "fas fa-arrow-down-z-a" },
      ];
    },

    create_doc_placeholder() {
      if (this.create_doc_kind === "word") return "e.g. Tenant Agreement";
      if (this.create_doc_kind === "excel") return "e.g. Budget Sheet";
      if (this.create_doc_kind === "powerpoint") return "e.g. Project Pitch Deck";
      return "e.g. Untitled";
    },

    share_item_label() {
      return this.share_file?.type === 'folder' ? 'Folder' : 'File';
    },

    user_access_level_name() {
      const level = this.access_levels.find((item) => String(item.id) === String(this.user_access_level));
      return level?.name || "";
    },

    empty_state_title() {
      const titles = {
        my: "No files or folders here.",
        shared: "No shared files yet.",
        recent: "No recent files found.",
        starred: "No starred files yet.",
        trash: "Trash is empty.",
        admin:   "This drive is empty."
      };
      return titles[this.drive_section] || "No files found.";
    },

    empty_state_subtitle() {
      if (this.drive_section === "my") return "Use the New button to create or upload.";
      if (this.drive_section === "starred") return "Use the item menu to add files or folders to Starred.";
      return "";
    },

    section_context_label() {
      return DRIVE_SECTION_LABELS.get(this.drive_section) || "";
    },

    mobile_user_email() {
      return parse_stored_user()?.email || "";
    },

    mobile_user_initial() {
      const email = this.mobile_user_email;
      if (email) return email.charAt(0).toUpperCase();
      return "A";
    },

    current_user_display_name() {
      const user = parse_stored_user();
      const fallback_email = this.mobile_user_email || "";
      return [user?.name, user?.full_name, user?.username, user?.email, fallback_email].find(Boolean) || "";
    },

    current_user_id() {
      const user = parse_stored_user();
      return Number(user?.id || localStorage.getItem("user_id") || 0) || null;
    },

    storage_percentage() {
      const percentage = Number(this.storage_stats?.percentage_used || 0);
      if (!Number.isFinite(percentage)) return 0;
      return Math.min(100, Math.max(0, percentage));
    },

    storage_summary() {
      const used = Number(this.storage_stats?.used_gb || 0);
      const total = Number(this.storage_stats?.total_gb || 0);
      if (!total) return "Storage unavailable";
      return `${used.toFixed(2)} GB of ${total.toFixed(2)} GB used`;
    },

    has_copied_file() {
      return Boolean(this.copied_file?.id);
    },

    copied_file_name() {
      return this.copied_file?.name || '';
    },
  },

  mounted() {
    this.load_copied_file_from_session();
    this.is_demo_domain = is_demo_domain();
    this.drive_id = get_drive_id() || (this.is_demo_domain ? 'demo-drive' : null);
    this.apply_route_deep_link();

    this.load_starred_items();
    this.fetch_drive_items();
    this.fetch_storage_stats();
    this.drive_id = get_drive_id() || this.drive_id;
    this.load_local_timestamps();

    this._drive_visibility_handler = () => {
      if (document.visibilityState === "hidden") {
        this.drive_was_hidden = true;
        return;
      }
      if (document.visibilityState === "visible") {
        if (!this.drive_was_hidden) return;
        this.drive_was_hidden = false;
        this.schedule_active_drive_refresh({ include_storage: true });
      }
    };
    this._drive_focus_handler = () => {
      if (this.drive_was_hidden && document.visibilityState !== "hidden") {
        this.drive_was_hidden = false;
        this.schedule_active_drive_refresh({ include_storage: true });
      }
    };
    document.addEventListener("visibilitychange", this._drive_visibility_handler);
    window.addEventListener("focus", this._drive_focus_handler);

    // Close dropdowns if clicking outside
    this._document_click_handler = (e) => {
      if (!e.target.closest('.dropdown')) {
        this.close_all_dropdowns();
      }

      if (
        !e.target.closest('.gc-portal-menu') &&
        !e.target.closest('.gc-kebab-btn') &&
        !this.is_point_inside_action_menu(e)
      ) {
        this.close_mobile_action_menu();
      }

      if (!e.target.closest('.drive-mobile-sort-wrap')) {
        this.close_mobile_sort_menu();
      }

      if (!e.target.closest('.drive-mobile-new-wrap') && !e.target.closest('.drive-mobile-new-menu')) {
        this.close_mobile_new_menu();
      }

      if (!e.target.closest('.drive-breadcrumb-overflow')) {
        this.close_breadcrumb_overflow();
      }
    };

    document.addEventListener('click', this._document_click_handler);
    this._scroll_handler = (event) => {
      if (event?.target?.closest?.('.gc-portal-menu')) return;
      this.close_mobile_action_menu();
    };
    window.addEventListener('scroll', this._scroll_handler, true);
    this._keydown_handler = (event) => {
      const is_paste_shortcut = (event.ctrlKey || event.metaKey) && event.key?.toLowerCase() === 'v';
      if (!is_paste_shortcut || this.is_text_input_target(event.target) || !this.has_copied_file) return;

      event.preventDefault();
      this.paste_copied_file();
    };
    window.addEventListener('keydown', this._keydown_handler);


    // Page-level drag detection for drop overlay
    this._dragenter_handler = () => { this.page_drag_active = true; };
    this._dragleave_handler = (e) => {
      if (e.clientX === 0 && e.clientY === 0) this.page_drag_active = false;
    };
    this._drop_handler = () => { this.page_drag_active = false; };
    document.addEventListener('dragenter', this._dragenter_handler);
    document.addEventListener('dragleave', this._dragleave_handler);
    document.addEventListener('drop',      this._drop_handler);

    this._modal_hidden_handler = (event) => {
      const modal_id = event.target?.id;

      if (modal_id === 'upload_files_modal') {
        this.reset_upload_modal_state();
      }

      if (modal_id === 'create_folder_modal') {
        this.new_folder_name = "";
        this.uploading_in_progress = false;
      }

      if (modal_id === 'create_doc_modal') {
        this.new_doc_title = "";
        this.create_doc_kind = null;
        this.uploading_in_progress = false;
      }

      if (modal_id === 'share_modal') {
        this.share_link = "";
        this.selected_access_level = '';
        this.share_file = null;
      }

      if (modal_id === 'share_user_modal') {
        this.reset_share_user_state();
        this.share_file = null;
      }

      if (modal_id === 'preview_file_modal') {
        this.preview_file_name = "";
        this.preview_file_url = "";
        this.preview_file_access_level = null;
      }

      if (modal_id === 'office_modal') {
        this.office_editor_url = null;
        this.office_file_name = '';
        this.office_loading = false;
        this.schedule_active_drive_refresh();
        this.apply_local_timestamps();
      }

      if (modal_id === 'rename_item_modal') {
        this.rename_item = null;
        this.rename_new_name = "";
        this.rename_in_progress = false;
      }

      if (modal_id === 'transfer_ownership_modal') {
        this.transfer_item = null;
        this.transfer_target_user_id = null;
        this.transfer_user_query = '';
        this.filtered_transfer_users = [];
        this.transfer_in_progress = false;
      }

    };

    document.querySelectorAll('.modal').forEach((modal_el) => {
      modal_el.addEventListener('hidden.bs.modal', this._modal_hidden_handler);
    });
  },

  beforeUnmount() {
    if (this.drive_refresh_debounce_id) {
      clearTimeout(this.drive_refresh_debounce_id);
      this.drive_refresh_debounce_id = null;
    }

    if (this._drive_visibility_handler) {
      document.removeEventListener("visibilitychange", this._drive_visibility_handler);
      this._drive_visibility_handler = null;
    }

    if (this._drive_focus_handler) {
      window.removeEventListener("focus", this._drive_focus_handler);
      this._drive_focus_handler = null;
    }

    if (this._document_click_handler) {
      document.removeEventListener('click', this._document_click_handler);
    }

    if (this._dragenter_handler) {
      document.removeEventListener('dragenter', this._dragenter_handler);
    }

    if (this._dragleave_handler) {
      document.removeEventListener('dragleave', this._dragleave_handler);
    }

    if (this._drop_handler) {
      document.removeEventListener('drop', this._drop_handler);
    }

    if (this._modal_hidden_handler) {
      document.querySelectorAll('.modal').forEach((modal_el) => {
        modal_el.removeEventListener('hidden.bs.modal', this._modal_hidden_handler);
      });
    }

    if (this._scroll_handler) {
      window.removeEventListener('scroll', this._scroll_handler, true);
      this._scroll_handler = null;
    }

    if (this._keydown_handler) {
      window.removeEventListener('keydown', this._keydown_handler);
      this._keydown_handler = null;
    }
    this.set_mobile_drive_scroll_lock(false);
  },

  watch: {
    mobile_drive_drawer_open(is_open) {
      this.set_mobile_drive_scroll_lock(is_open);
    },

    share_mode() {
      this.share_link = "";
      this.selected_access_level = "";
      this.user_access_level = "";
      this.set_default_media_access_level();
    },

    available_users() {
      if (this.transfer_item) {
        // Keep the transfer list in sync when users finish loading
        this.filter_transfer_users();
      }
    },
  },
  methods: {
    apply_route_deep_link() {
      const section = this.$route?.query?.section;
      if (["my", "shared", "recent", "starred", "trash", "admin"].includes(section)) {
        this.drive_section = section;
      }
    },

    find_drive_item_by_id(item_id) {
      return this.drive_items.find((drive_item) => (
        String(drive_item.id) === String(item_id)
      ));
    },

    open_drive_item_by_id(item_id) {
      const item = this.find_drive_item_by_id(item_id);
      if (!item) return false;

      this.route_drive_item_opened = true;
      this.open_item(item);
      return true;
    },

    open_route_drive_item_if_needed() {
      if (this.route_drive_item_opened || this.route_share_token_resolving) return;

      const route_item_id = this.$route?.query?.drive_item_id;
      if (route_item_id && this.open_drive_item_by_id(route_item_id)) return;

      const share_token = this.$route?.query?.share_token;
      if (!share_token) return;

      const token = get_token();
      if (!token) {
        this.$router.push({ name: "Login" });
        return;
      }

      this.route_share_token_resolving = true;
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/resolve_shared_drive_token/`;

      $.ajax({
        url,
        method: "GET",
        data: { share_token },
        headers: {
          "Authorization": `Token ${token}`,
          "X-Page-URL": window.location.href,
        },
        success: (response) => {
          const response_data = typeof response === "string" ? JSON.parse(response) : response;
          const item_id = response_data?.data?.drive_item_id;
          if (!item_id || !this.open_drive_item_by_id(item_id)) {
            this.route_drive_item_opened = true;
          }
          this.route_share_token_resolving = false;
        },
        error: (xhr) => {
          this.route_drive_item_opened = true;
          this.route_share_token_resolving = false;
          if (xhr.status === 401) this.$router.push({ name: "Login" });
          else this.$notyf.error(xhr?.responseJSON?.message || "Unable to open shared item.");
        },
      });
    },

    build_copied_file_payload(file) {
      return ({
        id: file.id,
        name: file.name,
        parent_folder: file.parent_id || null,
        parent_folder_id: file.parent_folder_id || null,
      });
    },

    persist_copied_file() {
      if (!this.copied_file) {
        sessionStorage.removeItem('aic_drive_copied_file');
        return;
      }

      sessionStorage.setItem('aic_drive_copied_file', JSON.stringify(this.copied_file));
    },

    load_copied_file_from_session() {
      const raw_value = sessionStorage.getItem('aic_drive_copied_file');
      if (!raw_value) return;

      try {
        const parsed_value = JSON.parse(raw_value);
        this.copied_file = parsed_value?.id ? parsed_value : null;
      } catch {
        this.copied_file = null;
        sessionStorage.removeItem('aic_drive_copied_file');
      }
    },

    clear_copied_file() {
      this.copied_file = null;
      sessionStorage.removeItem('aic_drive_copied_file');
      this.$notyf.info('Copied file cleared.');
    },

    is_text_input_target(target) {
      if (!target) return false;
      const tag_name = target.tagName?.toLowerCase();
      return tag_name === 'input' || tag_name === 'textarea' || target.isContentEditable;
    },

    get_modal_instance(modal_id) {
      const modal_el = document.getElementById(modal_id);
      if (!modal_el) return null;
      return Modal.getOrCreateInstance(modal_el);
    },

    show_modal(modal_id) {
      const modal = this.get_modal_instance(modal_id);
      if (modal) modal.show();
    },

    hide_modal(modal_id) {
      const modal = this.get_modal_instance(modal_id);
      if (modal) modal.hide();
    },

    create_context_drive_id() {
      return this.current_drive_id || this.drive_id;
    },

    can_create_in_current_folder() {
      if (!this.current_folder_id) return false;
      const folder = this.breadcrumb_path[this.breadcrumb_path.length - 1]
        || this.section_items.find((item) => item.id === this.current_folder_id);
      return !folder || this.can_edit(folder);
    },

    ensure_my_drive_create_context() {
      if (this.current_folder_id) {
        if (this.can_create_in_current_folder()) return true;
        this.$notyf.error("You do not have permission to add items to this folder.");
        return false;
      }

      if (this.drive_section === "my") return true;
      this.drive_section = "my";
      this.current_folder = "My Drive";
      this.current_folder_id = null;
      this.current_drive_id = null;
      this.fileTypeFilter = "all";
      this.fetch_drive_items("my");
      return true;
    },

    open_create_folder_modal() {
      if (!this.ensure_my_drive_create_context()) return;
      this.new_folder_name = "";
      this.show_modal('create_folder_modal');
    },

    open_upload_modal() {
      if (!this.ensure_my_drive_create_context()) return;
      this.reset_upload_modal_state();
      this.show_modal('upload_files_modal');
    },

    open_preview_modal() {
      this.show_modal('preview_file_modal');
    },

    close_preview_modal() {
      this.hide_modal('preview_file_modal');
    },

    open_share_modal() {
      this.show_modal('share_modal');
    },

    close_share_modal() {
      this.hide_modal('share_modal');
    },

    open_share_user_modal() {
      this.show_modal('share_user_modal');
    },

    close_share_user_modal() {
      this.hide_modal('share_user_modal');
    },

    open_office_modal() {
      this.show_modal('office_modal');
    },

    close_office_modal() {
      this.hide_modal('office_modal');
    },

    open_editor_tab(editor_url, tab_key) {
      this.office_editor_url = null;
      this.office_file_name = '';
      this.office_loading = false;

      const editor_tab = window.open(editor_url, tab_key);
      if (!editor_tab) {
        this.$notyf.error("Popup blocked. Please allow popups for AIC Drive and try again.");
        return false;
      }

      if (editor_tab.focus) editor_tab.focus();
      return true;
    },

    acquire_editor_lock(lock_key, ttl_ms = 1500) {
      const now = Date.now();
      const locked_at = Number(Reflect.get(this.editor_open_locks, lock_key) || 0);

      if (locked_at && now - locked_at < ttl_ms) return false;

      Reflect.set(this.editor_open_locks, lock_key, now);
      return true;
    },

    release_editor_lock(lock_key) {
      Reflect.set(this.editor_open_locks, lock_key, 0);
    },

    is_folder(file) {
      return file?.type === 'folder';
    },

    is_shared_item(file) {
      return Boolean(file?.shared_access_level);
    },

    is_starred_item(file) {
      return Boolean(file?.is_starred) || this.starred_item_ids.includes(String(file?.id || ""));
    },

    is_trashed_item(file) {
      return Boolean(file?.is_trashed);
    },

    shared_access_name(file) {
      return file?.shared_access_level?.name || "";
    },

    admin_drive_initials(drive) {
      const label = drive?.owner || drive?.name || "";
      const parts = label.trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return "DR";
      return parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join("");
    },

    refresh_drive_context() {
      if (this.drive_section === "admin") {
        this.fetch_admin_drives();
        return;
      }
      this.fetch_drive_items(this.drive_section, { silent: true });
    },

    schedule_active_drive_refresh({ include_storage = false, delay = 600 } = {}) {
      if (this.drive_refresh_debounce_id) clearTimeout(this.drive_refresh_debounce_id);

      this.drive_refresh_debounce_id = setTimeout(() => {
        this.drive_refresh_debounce_id = null;
        this.refresh_drive_context();
        if (include_storage) this.fetch_storage_stats();
      }, delay);
    },

    response_drive_data(response_data) {
      return response_data?.data ?? response_data;
    },

    first_array_drive_item(data) {
      if (!Array.isArray(data)) return null;
      return Reflect.get(data, 0) || null;
    },

    nested_response_drive_item(data) {
      if (!data || typeof data !== "object" || Array.isArray(data)) return null;

      for (const key of RESPONSE_DRIVE_ITEM_KEYS) {
        if (!RESPONSE_DRIVE_ITEM_KEYS.includes(key)) continue;
        const value = Reflect.get(data, key);
        if (value && typeof value === "object") return value;
      }

      return data;
    },

    response_drive_item(response_data) {
      const data = this.response_drive_data(response_data);
      return this.first_array_drive_item(data) || this.nested_response_drive_item(data);
    },

    local_drive_item_base(overrides = {}) {
      const now = new Date().toISOString();
      return ({
        id: overrides.id || `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        drive_id: this.create_context_drive_id(),
        owner: this.current_user_display_name || "",
        created_by: this.current_user_display_name || "",
        parent_folder: this.current_folder || "My Drive",
        parent_folder_id: this.current_folder_id,
        created_at: now,
        modified_at: now,
        activity_at: now,
        ...overrides,
      });
    },

    upsert_local_drive_item(raw_item, fallback = {}) {
      const base_item = this.local_drive_item_base(fallback);
      const raw_object = this.sanitize_drive_item_payload(raw_item);
      const normalized_item = this.normalize_drive_item({ ...base_item, ...raw_object });
      const index = this.drive_items.findIndex((item) => String(item.id) === String(normalized_item.id));

      if (index >= 0) {
        this.drive_items.splice(index, 1, normalized_item);
      } else {
        this.drive_items = [normalized_item, ...this.drive_items];
      }

      this.apply_local_timestamps();
      return normalized_item;
    },

    sanitize_drive_item_payload(raw_item) {
      if (!raw_item || typeof raw_item !== "object" || Array.isArray(raw_item)) return {};

      return LOCAL_DRIVE_ITEM_KEYS.reduce((safe_item, key) => {
        if (!LOCAL_DRIVE_ITEM_KEYS.includes(key)) return safe_item;
        const value = Reflect.get(raw_item, key);
        if (value === undefined || value === null) return safe_item;
        Reflect.set(safe_item, key, value);
        return safe_item;
      }, {});
    },

    remove_local_drive_item(item_id) {
      this.drive_items = this.drive_items.filter((item) => String(item.id) !== String(item_id));
    },

    switch_drive_section(section) {
      if (!["my", "shared", "recent", "starred", "trash", "admin"].includes(section)) return;
      if (this.drive_section === section && section !== "admin") {
        this.mobile_drive_drawer_open = false;
        return;
      }
      this.drive_section = section;
      this.current_folder = this.root_label;
      this.current_folder_id = null;
      this.current_drive_id = null;
      this.fileTypeFilter = "all";
      this.mobile_drive_drawer_open = false;
      this.close_mobile_action_menu();
      this.close_all_dropdowns();

      // Reset admin state whenever we switch sections
      this.admin_selected_drive = null;
      this.admin_drives         = [];
      this.drive_items          = [];

      if (section === "admin") {
        this.drive_items_loading = false;
        this.fetch_admin_drives();
      } else {
        this.fetch_drive_items(section);
      }

    },

    toggle_mobile_drive_drawer() {
      this.mobile_drive_drawer_open = !this.mobile_drive_drawer_open;
      this.close_mobile_action_menu();
      this.close_mobile_sort_menu();
    },

    close_mobile_drive_drawer() {
      this.mobile_drive_drawer_open = false;
    },

    toggle_breadcrumb_overflow() {
      this.breadcrumb_overflow_open = !this.breadcrumb_overflow_open;
      this.close_mobile_action_menu();
      this.close_mobile_sort_menu();
      this.close_mobile_new_menu();
    },

    close_breadcrumb_overflow() {
      this.breadcrumb_overflow_open = false;
    },

    set_mobile_drive_scroll_lock(is_locked) {
      document.body.classList.toggle("drive-mobile-drawer-lock", is_locked);
      document.documentElement.classList.toggle("drive-mobile-drawer-lock", is_locked);
    },

    toggle_mobile_sort_menu() {
      this.mobile_sort_menu_open = !this.mobile_sort_menu_open;
      this.close_mobile_action_menu();
    },

    close_mobile_sort_menu() {
      this.mobile_sort_menu_open = false;
    },

    toggle_mobile_new_menu(event) {
      event?.stopPropagation();
      const rect = event?.currentTarget?.getBoundingClientRect();
      if (!rect) return;

      this.mobile_new_menu_open = !this.mobile_new_menu_open;
      this.close_mobile_action_menu();
      this.close_mobile_sort_menu();

      if (this.mobile_new_menu_open) {
        const menu_width = Math.min(240, window.innerWidth - 24);
        this.mobile_new_menu_style = {
          position: "fixed",
          top: `${rect.bottom + 6}px`,
          left: `${Math.min(rect.left, window.innerWidth - menu_width - 12)}px`,
          width: `${menu_width}px`,
          zIndex: 1060,
        };
      }
    },

    close_mobile_new_menu() {
      this.mobile_new_menu_open = false;
      this.mobile_new_menu_style = {};
    },

    set_sort_by(value) {
      this.sort_by = value;
      this.close_mobile_sort_menu();
    },

    sort_filtered_items(items) {
      const sorted = [...items];
      const folder_weight = (item) => item.type === "folder" ? 0 : 1;
      const time_of = (item) => Number(item.updated_ts || new Date(item.updated_at).getTime() || 0);
      const name_of = (item) => (item.name || "").toLowerCase();

      sorted.sort((a, b) => {
        const folder_delta = folder_weight(a) - folder_weight(b);
        if (folder_delta !== 0) return folder_delta;

        if (this.sort_by === "oldest") return time_of(a) - time_of(b);
        if (this.sort_by === "name_asc") return name_of(a).localeCompare(name_of(b));
        if (this.sort_by === "name_desc") return name_of(b).localeCompare(name_of(a));
        return time_of(b) - time_of(a);
      });

      return sorted;
    },

    focus_mobile_drive_search() {
      this.$nextTick(() => {
        const search_input = document.querySelector(".drive-shell .filter-input-drive");
        if (search_input) search_input.focus();
      });
    },

    top_level_items_for(items) {
      return items.filter((item) => this.is_top_level_item(item, items));
    },

    is_child_of_current_folder(item) {
      if (item.parent_folder_id !== null && item.parent_folder_id !== undefined) {
        return String(item.parent_folder_id) === String(this.current_folder_id);
      }

      return (
        item.parent_id === this.current_folder &&
        item.drive_id === this.current_drive_id
      );
    },

    is_top_level_item(item, items) {
      if (item.parent_folder_id !== null && item.parent_folder_id !== undefined) {
        const has_visible_parent = items.some(
          (folder) => folder.type === "folder" && String(folder.id) === String(item.parent_folder_id)
        );
        return !has_visible_parent;
      }

      const has_visible_parent = items.some(
        (folder) => folder.type === "folder" && folder.name === item.parent_id && folder.drive_id === item.drive_id
      );
      return !item.parent_id || item.parent_id === "My Drive" || !has_visible_parent;
    },

    admin_visible_item_count(drive) {
      if (Array.isArray(drive?.items)) {
        const items = drive.items.map((item) => this.normalize_drive_item(item));
        return this.top_level_items_for(items).length;
      }

      return Number(drive?.item_count || 0);
    },

    load_starred_items() {
      const raw = JSON.parse(localStorage.getItem("drive_starred_items") || "[]");
      this.starred_item_ids = Array.isArray(raw) ? raw.map(String) : [];
    },

    persist_starred_items() {
      localStorage.setItem("drive_starred_items", JSON.stringify(this.starred_item_ids));
    },

    normalize_drive_item_id(item_id) {
      const id = String(item_id || "");
      return id || "";
    },

    is_matching_drive_item(item, item_id) {
      return String(item?.id) === String(item_id);
    },

    add_starred_item_id(item_id) {
      if (!this.starred_item_ids.includes(item_id)) {
        this.starred_item_ids.push(item_id);
      }
    },

    remove_starred_item_id(item_id) {
      const index = this.starred_item_ids.indexOf(item_id);
      if (index >= 0) this.starred_item_ids.splice(index, 1);
    },

    update_starred_item_ids(item_id, is_starred) {
      if (is_starred) {
        this.add_starred_item_id(item_id);
        return;
      }

      this.remove_starred_item_id(item_id);
    },

    update_drive_item_starred_state(item, item_id, is_starred) {
      return this.is_matching_drive_item(item, item_id) ? { ...item, is_starred } : item;
    },

    sync_drive_items_starred_state(item_id, is_starred) {
      this.drive_items = this.drive_items.map((item) => (
        this.update_drive_item_starred_state(item, item_id, is_starred)
      ));
    },

    sync_portal_file_starred_state(item_id, is_starred) {
      if (!this.is_matching_drive_item(this.portal_file, item_id)) return;
      this.portal_file = { ...this.portal_file, is_starred };
    },

    set_item_starred(item_id, is_starred) {
      const id = this.normalize_drive_item_id(item_id);
      if (!id) return;

      this.update_starred_item_ids(id, is_starred);
      this.persist_starred_items();
      this.sync_drive_items_starred_state(id, is_starred);
      this.sync_portal_file_starred_state(id, is_starred);
    },

    get_authenticated_token() {
      const token = get_token();
      if (!token) this.$router.push({ name: 'Login' });
      return token;
    },

    build_toggle_star_payload(file) {
      return ({ item_id: file.id, drive_item_id: file.id });
    },

    is_success_response(response_data) {
      return !response_data?.status || response_data.status === "success";
    },

    resolve_starred_response_state(response_data, fallback_value) {
      return Boolean(response_data?.data?.is_starred ?? response_data?.is_starred ?? fallback_value);
    },

    notify_starred_item_state(file, is_starred) {
      this.$notyf[is_starred ? "success" : "info"](
        `${is_starred ? "Added" : "Removed"} "${file.name}" ${is_starred ? "to" : "from"} Starred.`
      );
    },

    refresh_starred_section_after_toggle(file, is_starred) {
      if (this.drive_section === "starred" && !is_starred) {
        this.drive_items = this.drive_items.filter((item) => String(item.id) !== String(file?.id));
        return;
      }
    },

    handle_toggle_star_success(response_data, file, was_starred) {
      if (!this.is_success_response(response_data)) {
        throw new Error(response_data.message || "Failed to update star.");
      }

      const is_starred = this.resolve_starred_response_state(response_data, !was_starred);
      this.set_item_starred(file.id, is_starred);
      this.notify_starred_item_state(file, is_starred);
      this.refresh_starred_section_after_toggle(file, is_starred);
    },

    handle_toggle_star_error(error_info, file, was_starred) {
      this.set_item_starred(file.id, was_starred);
      const xhr = error_info?.xhr;
      this.$notyf.error(xhr?.responseJSON?.message || error_info?.message || "Failed to update star.");
    },

    async toggle_starred_item(file) {
      const id = this.normalize_drive_item_id(file?.id);
      if (!id) return;

      const token = this.get_authenticated_token();
      if (!token) return;

      const was_starred = this.is_starred_item(file);
      this.set_item_starred(file.id, !was_starred);
      this.close_mobile_action_menu();

      try {
        const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/toggle_star/`;
        const rd = await this.ajax_json_request({
          url,
          method: "POST",
          token,
          payload: this.build_toggle_star_payload(file),
        });

        this.handle_toggle_star_success(rd, file, was_starred);
      } catch (error_info) {
        this.handle_toggle_star_error(error_info, file, was_starred);
      }
    },

    is_point_inside_action_menu(event) {
      const menu = this.$refs.actionMenu;
      if (!menu || typeof event?.clientX !== 'number' || typeof event?.clientY !== 'number') return false;

      const rect = menu.getBoundingClientRect();
      return (
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
      );
    },

    position_action_menu(anchor_rect) {
      if (!anchor_rect) return;

      const menu = this.$refs.actionMenu;
      const MENU_WIDTH = Math.min(260, window.innerWidth - 16);
      const MAX_MENU_HEIGHT = Math.min(430, window.innerHeight - 16);
      const GAP = 6;
      const VP_PAD = 8;
      const measured_height = Math.min(menu?.offsetHeight || MAX_MENU_HEIGHT, MAX_MENU_HEIGHT);

      const space_below = window.innerHeight - anchor_rect.bottom - VP_PAD;
      const space_above = anchor_rect.top - VP_PAD;
      const open_up = space_below < measured_height + GAP && space_above > space_below;

      let top = open_up
        ? anchor_rect.top - measured_height - GAP
        : anchor_rect.bottom + GAP;

      if (top + measured_height > window.innerHeight - VP_PAD) {
        top = window.innerHeight - VP_PAD - measured_height;
      }

      top = Math.max(VP_PAD, top);

      const left = Math.min(
        Math.max(VP_PAD, anchor_rect.right - MENU_WIDTH),
        window.innerWidth - MENU_WIDTH - VP_PAD
      );

      this.portal_style = {
        position: 'fixed',
        top: `${top}px`,
        left: `${left}px`,
        width: `${MENU_WIDTH}px`,
        maxHeight: `${MAX_MENU_HEIGHT}px`,
        zIndex: 99999,
      };
    },

    toggle_mobile_action_menu(event, file) {
      event?.stopPropagation();
      // If clicking the same file's kebab → close it
      if (this.portal_file && this.portal_file.id === file.id) {
        this.close_mobile_action_menu();
        return;
      }

      const MENU_WIDTH = Math.min(260, window.innerWidth - 16);
      const MAX_MENU_HEIGHT = Math.min(430, window.innerHeight - 16);
      const GAP = 8;
      const VP_PAD  = 8;
      const anchor_rect = event?.currentTarget?.getBoundingClientRect();
      const left = anchor_rect
        ? Math.min(Math.max(VP_PAD, anchor_rect.right - MENU_WIDTH), window.innerWidth - MENU_WIDTH - VP_PAD)
        : VP_PAD;
      const top = anchor_rect
        ? Math.min(anchor_rect.bottom + GAP, window.innerHeight - VP_PAD)
        : VP_PAD;

      this.portal_style = {
        position: 'fixed',
        top:      `${top}px`,
        left:     `${left}px`,
        width:    `${MENU_WIDTH}px`,
        maxHeight: `${MAX_MENU_HEIGHT}px`,
        visibility: 'hidden',
        zIndex:   99999,
      };

      this.portal_file          = file;
      this.open_mobile_action_id = file.id;

      this.$nextTick(() => this.position_action_menu(anchor_rect));
    },

    close_mobile_action_menu() {
      this.open_mobile_action_id = null;
      this.portal_file = null;
      this.portal_style = {};
    },

    open_details_panel(file) {
      this.details_file = file;
      this.details_shared_with_list = [];
      this.details_loading_shared_with = false;
      this.close_mobile_action_menu();
      this.load_details_shared_with(file);
    },

    close_details_panel() {
      this.details_file = null;
      this.details_shared_with_list = [];
      this.details_loading_shared_with = false;
    },

    share_from_details(file) {
      this.share_to_user(file);
    },

    load_details_shared_with(file) {
      if (!file) return;

      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }

      this.details_loading_shared_with = true;
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/get_shared_with/?drive_item_id=${file.id}`;

      $.ajax({
        url,
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: (response) => {
          const rd = typeof response === 'string' ? JSON.parse(response) : response;
          if (rd.status === 'success') {
            this.details_shared_with_list = rd.data || [];
          } else {
            this.$notyf.error(rd.message || 'Failed to load people with access.');
          }
          this.details_loading_shared_with = false;
        },
        error: (xhr) => {
          this.$notyf.error(xhr?.responseJSON?.message || 'Failed to load people with access.');
          this.details_loading_shared_with = false;
        },
      });
    },

    details_owner_email(file = this.details_file) {
      if (!file) return "";
      return file.owner_email || file.created_by_email || file.email || "";
    },

    details_collab_user_id(collab) {
      return collab.user_id || collab.id || collab.user?.id || null;
    },

    details_collab_name(collab) {
      return collab.name || collab.full_name || collab.user?.name || collab.user?.full_name || collab.email || 'User';
    },

    details_collab_email(collab) {
      return collab.email || collab.user?.email || '';
    },

    details_collab_access_level(collab) {
      const access_level = collab.access_level || collab.access_level_name || collab.role || 'Viewer';
      const normalized = String(access_level || '').trim();
      if (!normalized) return 'Viewer';
      return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
    },

    details_collab_source(collab) {
      if (collab.inherited || String(collab.access_source || '').toLowerCase() === 'inherited') {
        return 'Inherited';
      }
      const source = String(collab.access_source || '').trim();
      if (!source) return 'Direct';
      return source.charAt(0).toUpperCase() + source.slice(1).toLowerCase();
    },

    details_access_badge_class(access_level) {
      const level = String(access_level || '').toLowerCase();
      if (level === 'editor') return 'bg-success text-white';
      if (level === 'commenter') return 'bg-primary text-white';
      return 'bg-secondary text-white';
    },

    can_remove_details_access(collab) {
      if (!collab) return false;
      if (collab.inherited || this.details_collab_source(collab) === 'Inherited') return false;
      if (collab.can_remove === false || collab.can_revoke === false) return false;
      return Boolean(this.details_collab_user_id(collab));
    },

    async remove_details_user_access(collab) {
      if (!this.details_file || !this.can_remove_details_access(collab)) return;

      const user_id = this.details_collab_user_id(collab);

      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      this.revoking_user_id = user_id;

      $.ajax({
        url: `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/revoke_share/`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          drive_item_id: this.details_file.id,
          user_id,
        }),
        headers: {
          Authorization: `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: (response) => {
          const rd = typeof response === 'string' ? JSON.parse(response) : response;

          if (rd.status === 'success') {
            this.$notyf.success('Access removed.');
            this.load_details_shared_with(this.details_file);
          } else {
            this.$notyf.error(rd.message || 'Failed to remove access.');
          }

          this.revoking_user_id = null;
        },
        error: (xhr) => {
          this.$notyf.error(xhr?.responseJSON?.message || 'Failed to remove access.');
          this.revoking_user_id = null;
        },
      });
    },

    format_file_size(bytes) {
      const size = Number(bytes || 0);
      if (!size) return "-";
      const units = ["B", "KB", "MB", "GB", "TB"];
      const index = Math.min(Math.floor(Math.log(size) / Math.log(1024)), units.length - 1);
      return `${(size / Math.pow(1024, index)).toFixed(index === 0 ? 0 : 1)} ${Reflect.get(units, index)}`;
    },

    details_access_label(file = this.details_file) {
      if (!file) return "";
      if (file.shared_access_level) return `You have ${file.shared_access_level.name} access`;
      if (this.details_loading_shared_with) return "Checking access";
      if (this.details_shared_with_list.length) return `Shared with ${this.details_shared_with_list.length} user(s)`;
      return "Only you have access";
    },

    item_detail_type(file) {
      if (this.is_folder(file)) return "Folder";
      return file.extension ? file.extension.toUpperCase() : "File";
    },

    item_detail_last_opened(file) {
      return file.last_opened_at || file.updated_at || "-";
    },

    item_detail_location(file) {
      return file.path || file.parent_id || this.root_label;
    },

    item_detail_size(file) {
      return this.is_folder(file) ? "-" : this.format_file_size(file.size);
    },

    build_item_detail_rows(file) {
      return [
        { label: "Type", value: this.item_detail_type(file) },
        { label: "Owner", value: this.item_owner_name(file) },
        { label: "Created", value: file.created_at || "-" },
        { label: "Modified", value: file.modified_at || "-" },
        { label: "Last opened", value: this.item_detail_last_opened(file) },
        { label: "Location", value: this.item_detail_location(file) },
        { label: "Size", value: this.item_detail_size(file) },
      ];
    },

    item_detail_rows(file = this.details_file) {
      if (!file) return [];
      return this.build_item_detail_rows(file);
    },

    start_preview(file) {
      this.hover_timer = setTimeout(() => { this.hovered_file = file; }, 500);
    },
    cancel_preview() {
      clearTimeout(this.hover_timer);
      this.hovered_file = null;
    },

    // Visual colour helpers
    file_type_color(file) {
      if (file.type === 'folder') return '#D4A020';
      const ext = this.ext_of(file.name);
      if (['doc', 'docx'].includes(ext)) return '#1B6BE0';
      if (['xls', 'xlsx', 'csv'].includes(ext)) return '#1C7C3A';
      if (ext === 'pdf') return '#C8102E';
      if (['ppt', 'pptx'].includes(ext)) return '#D4590A';
      if (['jpg','jpeg','png','gif','svg','bmp','webp'].includes(ext)) return '#7B3DB8';
      if (['mp4','mov','avi','mkv','flv','wmv','webm'].includes(ext)) return '#0F7490';
      return '#64748B';
    },
    file_icon_bg(file) { return this.file_type_color(file) + '18'; },
    file_icon_color(file) { return this.file_type_color(file); },

    owner_initials(name = '') {
      return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) || '?';
    },

    preview_thumb_bg(file) {
      const c = this.file_type_color(file);
      return `linear-gradient(135deg, ${c}cc, ${c}66)`;
    },

    open_create_doc_modal(file_kind) {
      if (!this.ensure_my_drive_create_context()) return;
      this.create_doc_kind = file_kind;
      this.new_doc_title = "";

      this.show_modal('create_doc_modal');

      this.$nextTick(() => {
        setTimeout(() => {
          const modal_el = document.getElementById('create_doc_modal');
          const input = modal_el?.querySelector('input');
          if (input) input.focus();
        }, 200);
      });
    },

    is_office_file(file) {
      if (!file || file.type === "folder") {
        return false;
      }

      const ext = this.ext_of(file.name);
      if (["html", "htm"].includes(ext)) return false;

      return [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "xlsm",
        "xlsb",
        "ppt",
        "pptx",
        "odt",
        "ods",
        "odp",
        "csv",
      ].includes(ext);
    },

    confirm_create_doc() {
      const name = (this.new_doc_title || "").trim();
      if (!name) { this.$notyf.info("Please enter a file name."); return; }
      this.create_office_file(this.create_doc_kind, name);
    },

    _set_bootstrap_tab(tab) {
      const allowed_tabs = Object.freeze(["folder", "upload", "workspace"]);
      if (!allowed_tabs.includes(tab)) return;

      const map = Object.freeze({
        folder: '[data-bs-target="#folder-pane"]',
        upload: '[data-bs-target="#upload-pane"]',
        workspace: '[data-bs-target="#workspace-pane"]',
      });

      const selector = Reflect.get(map, tab);

      if (typeof selector !== "string") return;

      const btn = document.querySelector(selector);
      if (!btn) return;

      // eslint-disable-next-line no-undef
      const instance = window.bootstrap?.Tab?.getOrCreateInstance(btn);
      if (instance) instance.show();
    },

    _safe_key_re() {
      return /^[A-Za-z0-9_.:~-]+$/;
    },

    _parse_opens_map() {
      let raw = null;
      try {
        raw = JSON.parse(localStorage.getItem('file_opens') || '{}');
      } catch {
        return new Map();
      }
      if (raw === null || typeof raw !== 'object') return new Map();

      const safe = this._safe_key_re();
      const max_future = Date.now() + 365 * 24 * 60 * 60 * 1000;
      const entries = [];

      for (const key of Object.keys(raw)) {
        if (this._is_valid_entry(raw, key, safe, max_future)) {
          const desc = Object.getOwnPropertyDescriptor(raw, key);
          const timestamp = this._extract_timestamp(desc.value);
          if (timestamp !== null) {
            entries.push([key, timestamp]);
          }
        }
      }
      return new Map(entries);
    },

    _is_valid_entry(raw, key, safe_regex, max_future) {
      if (!safe_regex.test(key)) return false;
      const desc = Object.getOwnPropertyDescriptor(raw, key);
      if (!desc || !desc.enumerable) return false;
      const timestamp = this._extract_timestamp(desc.value);
      return timestamp !== null && timestamp <= max_future;
    },

    _extract_timestamp(value) {
      const num = typeof value === 'string' ? value.trim() : String(value || '').trim();
      if (!/^\d{1,13}$/.test(num)) return null;
      const timestamp = Number(num);
      if (!Number.isFinite(timestamp) || timestamp <= 0) return null;
      return timestamp;
    },

    _persist_opens_map(opens_map) {
      const obj = Object.create(null);
      const safe = this._safe_key_re();

      for (const [k, v] of opens_map) {
        const key = String(k);
        if (!safe.test(key)) continue;
        const val = String(v).trim();
        if (!/^\d{1,13}$/.test(val)) continue;
        Object.defineProperty(obj, key, {
          value: val,
          writable: false,
          enumerable: true,
          configurable: false
        });
      }
      localStorage.setItem('file_opens', JSON.stringify(obj));
    },

    _get_open_ts(opens_map, id) {
      if (typeof id !== 'string' || !this._safe_key_re().test(id)) return null;
      return opens_map.get(id) ?? null;
    },

    _set_open_ts(opens_map, id, ts) {
      if (typeof id !== 'string' || !this._safe_key_re().test(id)) return;
      if (typeof ts !== 'number' || !Number.isFinite(ts) || ts <= 0) return;
      opens_map.set(id, ts);
    },

    _get_safe_property(obj, prop, default_value = '') {
      const desc = Object.getOwnPropertyDescriptor(obj, prop);
      if (!desc?.enumerable) return default_value;
      const value = desc.value;
      if (value === undefined || value === null) return default_value;
     if (typeof default_value === 'string') {
        return typeof value === 'string' ? value : String(value);
      }

      if (typeof default_value === 'number') {
        const num = Number(value);
        return Number.isFinite(num) ? num : default_value;
      }
      return value;
    },

    set_active_tab(tab) {
      this.active_tab = tab;
      this.$nextTick(() => {
        this._set_bootstrap_tab(tab);
      });
    },
    load_local_timestamps() {
      const opens_map = this._parse_opens_map();

      this.drive_items = this.drive_items.map((item) => {
        const local_ts = this._get_open_ts(opens_map, String(item.id));
        if (typeof local_ts === 'number' && local_ts > Number(item.updated_ts || 0)) {
          return {
            ...item,
            updated_ts: local_ts,
            updated_at: this.format_drive_date(new Date(local_ts)),
          };
        }
        return item;
      });
    },

    format_drive_date(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}/${month}/${day}, ${hours}:${minutes}:${seconds}`;
    },

    drive_section_endpoint(section = this.drive_section) {
      return DRIVE_SECTION_ENDPOINTS.get(section) || DRIVE_SECTION_ENDPOINTS.get("my");
    },

    normalize_drive_items_response(response_data) {
      if (Array.isArray(response_data)) return response_data;
      const data = response_data?.data;
      if (Array.isArray(data)) return this.flatten_drive_items(data);
      if (Array.isArray(data?.items)) return data.items;
      if (Array.isArray(data?.drive_items)) return data.drive_items;
      if (Array.isArray(response_data?.items)) return response_data.items;
      return [];
    },

    flatten_drive_items(items) {
      const flattened = [];
      const visit = (item) => {
        if (!item) return;
        const { children, ...item_without_children } = item;
        flattened.push(item_without_children);
        if (Array.isArray(children)) {
          children.forEach(visit);
        }
      };
      items.forEach(visit);
      return flattened;
    },

    first_present_value(values, fallback = "") {
      const value = values.find((entry) => entry);
      if (value) return value;
      if (fallback) return fallback;
      return "";
    },

    has_truthy_value(values) {
      return values.some((entry) => entry);
    },

    actor_display_name(actor, fallback = "") {
      if (!actor) return fallback || "";
      if (typeof actor === "string") return actor;
      return this.first_present_value([actor.name, actor.full_name, actor.username, actor.email], fallback);
    },

    drive_item_raw_dates(item) {
      const raw_created_at = item.created_at || null;
      const raw_modified_at = item.updated_at || null;
      const raw_last_opened_at = item.last_opened_at || item.opened_at || null;
      const raw_activity_at = raw_last_opened_at || raw_modified_at || raw_created_at;
      return ({ raw_created_at, raw_modified_at, raw_last_opened_at, raw_activity_at });
    },

    safe_drive_date(value) {
      return value ? new Date(value) : null;
    },

    drive_item_timestamp(date) {
      return date ? date.getTime() : 0;
    },

    drive_item_date_context(item) {
      const raw_dates = this.drive_item_raw_dates(item);
      const created_date = this.safe_drive_date(raw_dates.raw_created_at);
      const modified_date = this.safe_drive_date(raw_dates.raw_modified_at);
      const last_opened_date = this.safe_drive_date(raw_dates.raw_last_opened_at);
      const activity_date = this.safe_drive_date(raw_dates.raw_activity_at) || new Date();

      return ({
        ...raw_dates,
        created_date,
        modified_date,
        last_opened_date,
        activity_date,
        created_ts: this.drive_item_timestamp(created_date),
        modified_ts: this.drive_item_timestamp(modified_date),
        last_opened_ts: this.drive_item_timestamp(last_opened_date),
        activity_ts: this.drive_item_timestamp(activity_date),
      });
    },

    drive_item_parent_context(item) {
      return ({
        parent_folder: item.parent_folder || item.parent_name || item.parent_id || "My Drive",
        parent_folder_id: item.parent_folder_id ?? item.parent_item_id ?? null,
      });
    },

    drive_item_owner_source(item) {
      return this.first_present_value([
        item.owner,
        item.owner_name,
        item.drive_owner,
        item.drive_owner_name,
        item.owner_email,
      ]);
    },

    drive_item_created_by_source(item) {
      return this.first_present_value([
        item.created_by,
        item.created_by_name,
        item.creator,
        item.created_by_email,
      ]);
    },

    drive_item_actor_fields(item) {
      const owner_source = this.drive_item_owner_source(item);
      const owner = this.actor_display_name(owner_source);

      return ({
        owner_id: item.owner_id || item.drive_owner_id || null,
        owner_email: item.owner_email || item.drive_owner_email || "",
        owner,
        created_by_id: item.created_by_id || null,
        created_by: this.actor_display_name(this.drive_item_created_by_source(item), owner),
        shared_by_id: item.shared_by_id || null,
        shared_by: this.actor_display_name(
          this.first_present_value([item.shared_by, item.shared_by_name, item.shared_by_email])
        ),
      });
    },

    drive_item_permission_fields(item) {
      return ({
        can_manage: Boolean(item.can_manage),
        can_delete: Boolean(item.can_delete),
      });
    },

    drive_item_date_fields(date_context) {
      return ({
        created_at_raw: date_context.raw_created_at,
        created_at: date_context.created_date ? this.format_drive_date(date_context.created_date) : "",
        created_ts: date_context.created_ts,
        modified_at_raw: date_context.raw_modified_at,
        modified_at: date_context.modified_date ? this.format_drive_date(date_context.modified_date) : "",
        modified_ts: date_context.modified_ts,
        last_opened_at_raw: date_context.raw_last_opened_at,
        last_opened_at: date_context.last_opened_date ? this.format_drive_date(date_context.last_opened_date) : "",
        last_opened_ts: date_context.last_opened_ts,
        activity_at_raw: date_context.raw_activity_at,
        activity_at: this.format_drive_date(date_context.activity_date),
        activity_ts: date_context.activity_ts,
        updated_at_raw: date_context.raw_activity_at,
        updated_at: this.format_drive_date(date_context.activity_date),
        updated_ts: date_context.activity_ts,
        formatted_date: this.format_drive_date(date_context.activity_date),
      });
    },

    drive_item_type_value(item) {
      return this.first_present_value([item.item_type, item.type]);
    },

    drive_item_size_value(item) {
      return this.first_present_value([item.size, item.file_size, item.size_bytes], null);
    },

    drive_item_mime_type_value(item) {
      return this.first_present_value([item.mime_type, item.content_type, item.file_type]);
    },

    drive_item_extension_value(item) {
      return this.first_present_value([item.extension], this.ext_of(item.name));
    },

    drive_item_path_value(item) {
      return this.first_present_value([item.path, item.location, item.folder_path]);
    },

    drive_item_shared_access_level_value(item) {
      return this.first_present_value([item.shared_access_level], null);
    },

    drive_item_is_starred_value(item) {
      return this.has_truthy_value([item.is_starred, item.starred]);
    },

    drive_item_is_trashed_value(item) {
      return this.has_truthy_value([item.is_trashed, item.trashed, item.is_deleted, item.deleted_at]);
    },

    drive_item_last_opened_by_value(item) {
      return this.first_present_value([item.last_opened_by, item.opened_by, item.owner]);
    },

    drive_item_parent_id_value(parent_context) {
      return this.first_present_value([parent_context.parent_folder], "My Drive");
    },

    drive_item_identity_fields(item) {
      return ({
        id: item.id,
        drive_id: item.drive_id,
        name: item.name,
      });
    },

    drive_item_basic_fields(item) {
      const identity_fields = this.drive_item_identity_fields(item);

      return ({
        id: identity_fields.id,
        drive_id: identity_fields.drive_id,
        name: identity_fields.name,
        last_opened_by: this.drive_item_last_opened_by_value(item),
      });
    },

    drive_item_file_fields(item) {
      return ({
        type: this.drive_item_type_value(item),
        size: this.drive_item_size_value(item),
        mime_type: this.drive_item_mime_type_value(item),
        extension: this.drive_item_extension_value(item),
        path: this.drive_item_path_value(item),
      });
    },

    drive_item_parent_fields(parent_context) {
      return ({
        parent_id: this.drive_item_parent_id_value(parent_context),
        parent_folder_id: parent_context.parent_folder_id,
      });
    },

    drive_item_share_status_fields(item) {
      return ({
        shared_access_level: this.drive_item_shared_access_level_value(item),
        is_starred: this.drive_item_is_starred_value(item),
        is_trashed: this.drive_item_is_trashed_value(item),
      });
    },

    normalize_drive_item(item) {
      const date_context = this.drive_item_date_context(item);
      const parent_context = this.drive_item_parent_context(item);

      return ({
        ...this.drive_item_basic_fields(item),
        ...this.drive_item_file_fields(item),
        ...this.drive_item_parent_fields(parent_context),
        ...this.drive_item_share_status_fields(item),
        ...this.drive_item_actor_fields(item),
        ...this.drive_item_permission_fields(item),
        ...this.drive_item_date_fields(date_context),
      });
    },

    parse_ajax_response(response) {
      return typeof response === "string" ? JSON.parse(response) : response;
    },

    normalize_storage_stats(data) {
      return ({
        used_gb: Number(data.used_gb || 0),
        total_gb: Number(data.total_gb || 0),
        available_gb: Number(data.available_gb || 0),
        percentage_used: Number(data.percentage_used || 0),
      });
    },

    handle_storage_stats_success(response) {
      const response_data = this.parse_ajax_response(response);
      if (!this.is_success_response(response_data)) {
        console.error("Failed to load storage stats", response_data.message);
        return;
      }

      this.storage_stats = this.normalize_storage_stats(response_data?.data || response_data || {});
    },

    fetch_storage_stats() {
      const token = get_token();
      if (!token) return;
      const user_id = localStorage.getItem('user_id');
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/get_storage_stats/`;

      $.ajax({
        url,
        method: "GET",
        data: { user_id },
        headers: {
          "Authorization": `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: (response) => this.handle_storage_stats_success(response),
        error: (xhr) => {
          if (xhr.status !== 401) {
            console.error("Failed to fetch storage stats:", xhr.responseText || xhr.status);
          }
        },
      });
    },

    fetch_drive_items(section = this.drive_section, { silent = false } = {}) {
      if (section === "admin") {
        this.fetch_admin_drives();
        return;
      }

      const endpoint = this.drive_section_endpoint(section);
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/${endpoint}/`;
      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }
      const user_id = localStorage.getItem('user_id');
      const should_show_loader = !silent && this.drive_items.length === 0;

      const payload = {
        user_id: user_id
      };

      if (should_show_loader) {
        this.drive_items_loading = true;
      }

      $.ajax({
        url: url,
        method: "GET",
        data: payload,
        headers: {
          "Authorization": `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: (response) => {
          const response_data = typeof response === "string" ? JSON.parse(response) : response;

          if (!response_data.status || response_data.status === "success") {
            // Map backend items into frontend format
            const raw_items = this.normalize_drive_items_response(response_data);
            let items = raw_items.map((item) => this.normalize_drive_item(item));

            items.sort((a, b) => {
              if (a.type === b.type) {
                return Number(b.updated_ts || 0) - Number(a.updated_ts || 0); // newest first
              }
              return a.type === "folder" ? -1 : 1; // folders before files
            });
            this.drive_items = items;
            this.apply_local_timestamps();
            this.open_route_drive_item_if_needed();
          } else {
            console.error("Failed to load drive items", response_data.message);
          }
        },
        error: (xhr) => {
          if (xhr.status === 401) {
            this.$router.push({ name: 'Login' });
          } else {
            this.$notyf.error(xhr?.responseJSON?.message || `Failed to fetch drive items: HTTP ${xhr.status}`);
          }
        },
        complete: () => {
          if (should_show_loader) {
            this.drive_items_loading = false;
          }
        }
      });
    },

    can_download(file) {
      if (!file?.shared_access_level) return true;
      return file.shared_access_level.name !== "Viewer";
    },

    can_edit(file) {
      if (!file?.shared_access_level) return true;
      return file.shared_access_level.name === "Editor";
    },

    can_manage_file(file) {
      if (!file) return false;
      if (typeof file.can_manage === "boolean") return file.can_manage;
      return !file.shared_access_level;
    },

    can_delete_file(file) {
      if (!file) return false;
      if (typeof file.can_delete === "boolean") return file.can_delete;
      if (this.can_manage_file(file)) return true;
      return Boolean(file.created_by_id && file.created_by_id === this.current_user_id && file.shared_access_level);
    },

    can_share_file(file) {
      return this.can_manage_file(file);
    },

    can_copy_file(file) {
      return Boolean(file && !this.is_folder(file) && !this.is_trashed_item(file));
    },

    share_item_noun(item = this.share_file) {
      return item?.type === 'folder' ? 'folder' : 'file';
    },

    is_shared_root_view() {
      return this.drive_section === "shared" && !this.current_folder_id;
    },

    item_actor_label() {
      return this.is_shared_root_view() ? "Shared by:" : "Owner:";
    },

    item_actor_name(file) {
      if (!file) return "-";
      if (this.is_shared_root_view()) return file.shared_by || file.owner || "-";
      return file.created_by || file.owner || "-";
    },

    item_owner_name(file) {
      if (!file) return "-";
      return file.created_by || file.owner || "-";
    },

    item_grid_meta(file) {
      if (this.drive_section === "admin") return `Owner: ${file?.owner || "-"}`;
      if (this.is_shared_root_view()) return `Shared by: ${this.item_actor_name(file)}`;
      if (this.drive_section === "shared") return `Owner: ${this.item_actor_name(file)}`;
      if (this.drive_section === "my") return `Owner: ${this.item_actor_name(file)}`;
      return file?.updated_at || "";
    },

    list_actor_header() {
      return this.is_shared_root_view() ? "Shared by" : "Owner";
    },

    ajax_json_request({ url, method, payload, token }) {
      return new Promise((resolve, reject) => {
        $.ajax({
          url,
          method,
          contentType: "application/json",
          data: JSON.stringify(payload),
          headers: {
            "Authorization": `Token ${token}`,
            'X-Page-URL': window.location.href,
          },
          success: (response) => resolve(typeof response === 'string' ? JSON.parse(response) : response),
          error: (xhr, status, error) => reject({ xhr, status, error }),
        });
      });
    },

    navigate_to_folder(folder) {
      if (!folder) {
        if (this.drive_section === "admin") {
          this.admin_selected_drive = null;
          this.drive_items          = [];
          this.current_folder       = "All Drives";
          this.current_folder_id    = null;
          this.current_drive_id     = null;
          return;
        }
        this.current_folder    = this.root_label;
        this.current_folder_id = null;
        this.current_drive_id  = null;
      } else {
        this.current_folder    = folder.name;
        this.current_folder_id = folder.id;
        this.current_drive_id  = folder.drive_id;
      }
    },

    navigate_mobile_back() {
      if (this.current_folder_id) {
        const path = this.breadcrumb_path;
        const parent_folder = path.length > 1 ? path[path.length - 2] : null;
        this.navigate_to_folder(parent_folder);
        this.close_mobile_action_menu();
        this.close_mobile_sort_menu();
        return;
      }

      if (this.drive_section === "admin" && this.admin_selected_drive) {
        this.admin_selected_drive = null;
        this.drive_items          = [];
        this.current_folder       = "All Drives";
        this.current_folder_id    = null;
        this.current_drive_id     = null;
        this.close_mobile_action_menu();
        this.close_mobile_sort_menu();
      }
    },

    format_relative(ts) {
      if (!ts) return "just now";
      const diff = Date.now() - ts;
      const minutes = Math.round(diff / 60000);
      if (minutes < 1) return "just now";
      if (minutes < 60) return `${minutes} min ago`;
      const hours = Math.round(minutes / 60);
      if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
      const days = Math.round(hours / 24);
      if (days < 30) return `${days} day${days > 1 ? "s" : ""} ago`;
      const date = new Date(ts);
      return date.toLocaleDateString();
    },

    ext_of(name = '') {
      const dot = name.lastIndexOf('.');
      return dot >= 0 ? name.slice(dot + 1).toLowerCase() : '';
    },

    matches_chip(item, type) {
      if (item.type === 'folder') return type === 'all';
      const ext = this.ext_of(item.name);
      if (type === 'word')  return ['doc','docx'].includes(ext);
      if (type === 'excel') return ['xls','xlsx','csv'].includes(ext);
      if (type === 'ppt')   return ['ppt','pptx'].includes(ext);
      if (type === 'pdf')   return ext === 'pdf';
      if (type === 'image') return ['jpg','jpeg','png','gif','bmp','svg','webp'].includes(ext);
      if (type === 'video') return ['mp4','mov','avi','mkv','flv','wmv','webm','m4a'].includes(ext);
      return type === 'all';
    },

    file_icon(file, large = false) {
      if (file.type === 'folder') return large ? 'fas fa-folder fa-2x' : 'fas fa-folder';
      const ext = this.ext_of(file.name);
      let icon;
      switch (ext) {
        case 'pdf':                                   icon = 'far fa-file-pdf';        break;
        case 'doc':  case 'docx':                     icon = 'far fa-file-word';       break;
        case 'xls':  case 'xlsx': case 'csv':         icon = 'far fa-file-excel';      break;
        case 'ppt':  case 'pptx':                     icon = 'far fa-file-powerpoint'; break;
        case 'jpg':  case 'jpeg': case 'png':
        case 'gif':  case 'svg':  case 'bmp':
        case 'webp':                                  icon = 'far fa-file-image';      break;
        case 'mp4':  case 'mov':  case 'avi':
        case 'mkv':  case 'flv':  case 'wmv':
        case 'webm':                                  icon = 'far fa-file-video';      break;
        case 'mp3':  case 'm4a':  case 'wav':         icon = 'far fa-file-audio';      break;
        default:                                      icon = 'far fa-file';            break;
      }
      return large ? `${icon} fa-2x` : icon;
    },

    track_file_open(file_id) {
      const map = this._parse_opens_map();
      this._set_open_ts(map, String(file_id), Date.now());
      this._persist_opens_map(map);

      const token = get_token();
      if (!token) return;

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/record_file_open/`;
      this.ajax_json_request({
        url,
        method: "POST",
        token,
        payload: { item_id: file_id, drive_item_id: file_id },
      }).catch((error_info) => {
        const xhr = error_info?.xhr;
        console.error("Failed to record file open:", xhr?.responseText || error_info);
      });
    },

    apply_local_timestamps() {
      const map = this._parse_opens_map();
      this.drive_items = this.drive_items.map(item => {
        const id_desc = Object.getOwnPropertyDescriptor(item, 'id');
        if (!id_desc || !id_desc.enumerable) return item;
        const local_ts = this._get_open_ts(map, String(id_desc.value));
        if (typeof local_ts === 'number') {
          const back_ts  = Number(item.last_opened_ts || item.updated_ts || item.activity_ts || 0);
          if (local_ts > back_ts) {
            const opened_at = this.format_drive_date(new Date(local_ts));
            const opened_by = this.current_user_display_name || item.last_opened_by || item.owner || "";
            return Object.freeze({
              ...item,
              last_opened_at_raw: new Date(local_ts).toISOString(),
              last_opened_at: opened_at,
              last_opened_ts: local_ts,
              last_opened_by: opened_by,
              activity_at_raw: new Date(local_ts).toISOString(),
              activity_at: opened_at,
              activity_ts: local_ts,
              updated_at_raw: new Date(local_ts).toISOString(),
              updated_ts: local_ts,
              updated_at: opened_at,
              formatted_date: opened_at,
            });
          }
        }
        return item;
      });
    },

    open_item(file) {
      this.close_all_dropdowns();

      if (file.type === "folder") {
        this.navigate_to_folder(file);
        return;
      }

      this.track_file_open(file.id);

      const original = this.drive_items.find((item) => item.id === file.id);
      if (original) {
        const now = Date.now();
        const opened_at = this.format_drive_date(new Date(now));
        const opened_by = this.current_user_display_name || original.last_opened_by || original.owner || "";
        const updated = Object.freeze({
          ...original,
          last_opened_at_raw: new Date(now).toISOString(),
          last_opened_at: opened_at,
          last_opened_ts: now,
          last_opened_by: opened_by,
          activity_at_raw: new Date(now).toISOString(),
          activity_at: opened_at,
          activity_ts: now,
          updated_at_raw: new Date(now).toISOString(),
          updated_ts: now,
          updated_at: opened_at,
          formatted_date: opened_at,
        });

        const idx = this.drive_items.findIndex((item) => item.id === file.id);
        if (idx !== -1) {
          this.drive_items.splice(idx, 1, updated);
        }
      }

      this.preview_file(file);
    },

    handle_continue() {
      if (this.active_tab === 'folder')    this.create_folder_from_modal();
      else if (this.active_tab === 'upload') this.upload_file();
    },

    trigger_file_input() {
      const input = document.getElementById('drive_file_input');
      if (input) input.click();
    },

    handle_file_select(event) {
      const files = Array.from(event.target.files);
      const blocked = files.filter(file => this.is_html_file(file));
      this.uploads = files.filter(file => !this.is_html_file(file));

      if (blocked.length) {
        this.$notyf.error('HTML files are not supported.');
      }
    },

    handle_drop(event) {
      this.drag_over = false;
      this.handle_file_select({ target: { files: event.dataTransfer.files } });
    },

    reset_upload_modal_state() {
      this.drag_over            = false;
      this.uploads              = [];
      this.uploading_in_progress = false;
      this.$nextTick(() => {
        const input = document.getElementById('drive_file_input');
        if (input) input.value = '';
      });
    },

    is_html_file(file) {
      return ["html", "htm"].includes(this.ext_of(file?.name || ""));
    },

    upload_at(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.uploads.length) return null;
      return Reflect.get(this.uploads, index) || null;
    },

    create_folder_from_modal() {
      const folder_name = (this.new_folder_name || '').trim();
      if (!folder_name) { this.$notyf.info('Please enter a folder name.'); return; }
      const url   = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/create_folder/';
      const token = get_token();
      const drive_id = this.create_context_drive_id();
      if (!token || !drive_id) { this.$router.push({ name: 'Login' }); return; }
      this.uploading_in_progress = true;

      $.ajax({
        url, method: 'POST', contentType: 'application/json',
        data: JSON.stringify({ name: folder_name, parent_folder: this.current_folder || 'My Drive', drive_id, item_type_id: 1, parent_folder_id: this.current_folder_id, }),
        headers: { Authorization: `Token ${token}`, 'X-Page-URL': window.location.href },
        success: async (response) => {
          const rd = typeof response === 'string' ? JSON.parse(response) : response;
          if (rd.status === 'success') {
            this.$notyf.success('Folder created!');
            this.upsert_local_drive_item(this.response_drive_item(rd), {
              name: folder_name,
              type: "folder",
              item_type: "folder",
            });
            this.hide_modal('create_folder_modal');
          }
          else this.$notyf.error(rd?.message || 'Failed to create folder.');
          this.uploading_in_progress = false;
        },
        error: (xhr) => {
          if (xhr.status === 401) this.$router.push({ name: 'Login' });
          else this.$notyf.error(xhr?.responseJSON?.message || `Error: HTTP ${xhr.status}`);
          this.uploading_in_progress = false;
        },
      });
      this.new_folder_name = '';
    },

    async upload_files_from_modal() {
      await this.upload_file().catch(e => { console.error(e); });
    },

    async upload_file() {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/upload_file/';
      if (!this.uploads.length) { this.$notyf.info('Please select at least one file.'); return; }
      if (this.uploads.some(file => this.is_html_file(file))) {
        this.$notyf.error('HTML files are not supported.');
        return;
      }
      const token = get_token();
      const drive_id = this.create_context_drive_id();
      if (!token || !drive_id) { this.$router.push({ name: 'Login' }); return; }
      this.uploading_in_progress = true;

      const breadcrumb_string = [this.root_label, ...this.breadcrumb_path.map(f => f.name)].join('/');

      const get_file_type_id = (filename) => {
        const ext = filename.split('.').pop().toLowerCase();
        if (['pdf','doc','docx','xls','xlsx','ppt','pptx','txt','csv'].includes(ext)) return 1;
        if (['jpg','jpeg','png','gif','bmp','svg','webp'].includes(ext))              return 2;
        if (['mp4','mov','avi','mkv','flv','wmv','webm'].includes(ext))               return 3;
        if (['mp3','wav','ogg','aac','flac','m4a'].includes(ext))                     return 4;
        return 1;
      };

      const upload_single = (file) => new Promise((resolve, reject) => {
        const form_data = new FormData();
        form_data.append('file', file);
        form_data.append('name', file.name);
        form_data.append('parent_folder', this.current_folder || 'My Drive');
        form_data.append("parent_folder_id", this.current_folder_id ?? "");
        form_data.append('drive_id', drive_id);
        form_data.append('item_type_id', 2);
        form_data.append('file_type_id', get_file_type_id(file.name));
        form_data.append('size', file.size);
        form_data.append('breadcrumb_path', breadcrumb_string);

        $.ajax({
          url, method: 'POST', data: form_data, processData: false, contentType: false,
          headers: { Authorization: `Token ${token}`, 'X-Page-URL': window.location.href },
          success: (response) => {
            const rd = typeof response === 'string' ? JSON.parse(response) : response;
            if (rd.status === 'success') {
              resolve(rd);
            }
            else { this.$notyf.error(rd?.message || `Failed to upload ${file.name}`); reject(rd); }
          },
          error: (xhr) => {
            if (xhr.status === 403) this.$notyf.error(xhr.responseJSON?.message || `No permission to upload ${file.name}`);
            else if (xhr.status === 401) this.$router.push({ name: 'Login' });
            else this.$notyf.error(`Error uploading ${file.name}: HTTP ${xhr.status}`);
            reject(xhr);
          },
        });
      });

      try {
        const upload_results = await Promise.all(this.uploads.map(f => upload_single(f)));
        upload_results.forEach((rd, index) => {
          const file = this.upload_at(index);
          if (!file) return;
          this.upsert_local_drive_item(this.response_drive_item(rd), {
            name: file.name,
            type: "file",
            item_type: "file",
            size: file.size,
            extension: this.ext_of(file.name),
          });
        });
        this.$notyf.success('Files uploaded successfully!');
        this.hide_modal('upload_files_modal');
        this.fetch_storage_stats();
      } catch (e) {
        this.$notyf.error('Some files failed to upload.');
        throw e;
      } finally {
        this.uploading_in_progress = false;
      }
    },

    create_office_file(file_kind, title) {
      const token = get_token();
      const drive_id = this.create_context_drive_id();
      if (!token || !drive_id) { this.$router.push({ name: 'Login' }); return; }
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/api/create_empty_file_api/';
      this.uploading_in_progress = true;
      const breadcrumb_path = [this.root_label, ...this.breadcrumb_path.map(f => f.name)].join("/");

      const payload = {
        drive_id,
        item_type_id: 2,
        file_type_id: 1,
        parent_folder: this.current_folder || "My Drive",
        parent_folder_id: this.current_folder_id,
        breadcrumb_path: breadcrumb_path,
        file_kind: file_kind,
        file_name: title
      };

      $.ajax({
        url: url,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(payload),
        headers: {
          'Authorization': `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: async (response) => {
          const response_data = typeof response === 'string' ? JSON.parse(response) : response;

          if (response_data.status === "success") {
            this.$notyf.success('Empty file created successfully!');

            const editor_url = response_data?.data?.editor_url;
            const created_file_name = response_data?.data?.file_name || title;
            const drive_item_id = response_data?.data?.drive_item_id || response_data?.data?.id;
            const fallback_key = String(`${created_file_name}-${this.current_folder_id || 'root'}-${drive_id}`)
              .trim()
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "_")
              .replace(/^_+|_+$/g, "");
            const editor_key = drive_item_id || `new_${fallback_key || 'untitled'}`;
            const editor_lock_key = `editor_open_${editor_key}`;
            const editor_tab_name = drive_item_id
              ? `aic_drive_editor_${drive_item_id}`
              : `aic_drive_editor_${editor_key}`;
            this.upsert_local_drive_item(this.response_drive_item(response_data), {
              id: drive_item_id || undefined,
              name: created_file_name,
              type: "file",
              item_type: "file",
              extension: this.ext_of(created_file_name),
            });

            const modal_el = document.getElementById('create_doc_modal');
            const handle_hidden = async () => {
              modal_el?.removeEventListener('hidden.bs.modal', handle_hidden);

              if (editor_url && this.acquire_editor_lock(editor_lock_key)) {
                if (!this.open_editor_tab(editor_url, editor_tab_name)) {
                  this.release_editor_lock(editor_lock_key);
                }
              }

              this.fetch_storage_stats();
            };

            if (modal_el) {
              modal_el.addEventListener('hidden.bs.modal', handle_hidden, { once: true });
            }

            this.hide_modal('create_doc_modal');
          } else {
            this.$notyf.error(response_data?.message || 'Failed to create empty file.');
          }
          this.uploading_in_progress = false;
        },
        error: (xhr) => {
          if (xhr.status === 401) {
            this.$router.push({ name: 'Login' });
          } else if (xhr.status === 403) {
            this.$notyf.error("You do not have access to this drive.");
          } else {
            this.$notyf.error(xhr?.responseJSON?.message || `An error occurred while creating file: HTTP ${xhr.status}`);
          }
          this.uploading_in_progress = false;
        }
      });
    },

    toggle_dropdown(file_id) {
      this.open_dropdown_id = this.open_dropdown_id === file_id ? null : file_id;
      this.submenu_open = {};
    },

    share_to_user(file) {
      this.share_file = file;
      this.share_link = "";
      this.selected_access_level = "";
      this.user_access_level = "";
      this.share_mode = 'restricted';
      this.reset_share_user_state();
      this.fetch_available_users();
      this.fetch_user_access_levels();
      this.close_all_dropdowns();
      this.open_share_user_modal();
    },

    // CHANGED: now also resets shared_with_list, loading_shared_with, revoking_user_id
    reset_share_user_state() {
      this.selected_share_users = [];
      this.user_search_query = '';
      this.filtered_available_users = [];
      this.available_users = [];
      this.loading_users = false;
      this.users_error = null;
      this.sharing_in_progress = false;
      this.share_success = false;
      this.share_error = null;
      this.user_access_level = '';
      this.selected_access_level = '';
      this.share_link = '';
      this.shared_with_list = [];
      this.loading_shared_with = false;
      this.revoking_user_id = null;
    },

    // NEW: fetches current collaborators for the item
    load_shared_with(file) {
      if (!file || file.shared_access_level) return;

      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }

      this.loading_shared_with = true;
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/get_shared_with/?drive_item_id=${file.id}`;

      $.ajax({
        url, method: "GET",
        headers: { "Authorization": `Token ${token}`, 'X-Page-URL': window.location.href },
        success: (response) => {
          const rd = typeof response === 'string' ? JSON.parse(response) : response;
          if (rd.status === 'success') {
            this.shared_with_list = rd.data || [];
          } else {
            console.error('Failed to load shared-with list:', rd.message);
          }
          this.loading_shared_with = false;
        },
        error: (xhr) => {
          console.error('Error loading shared-with list:', xhr.responseText);
          this.loading_shared_with = false;
        },
      });
    },

    revoke_user_access(user_id) {
      if (!this.share_file) return;
      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }

      this.revoking_user_id = user_id;
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/revoke_share/`;

      $.ajax({
        url, method: "POST", contentType: "application/json",
        data: JSON.stringify({ drive_item_id: this.share_file.id, user_id }),
        headers: { "Authorization": `Token ${token}`, 'X-Page-URL': window.location.href },
        success: (response) => {
          const rd = typeof response === 'string' ? JSON.parse(response) : response;
          if (rd.status === 'success') {
            this.$notyf.success('Access revoked.');
            this.shared_with_list = this.shared_with_list.filter(u => u.user_id !== user_id);
          } else {
            this.$notyf.error(rd.message || 'Failed to revoke access.');
          }
          this.revoking_user_id = null;
        },
        error: (xhr) => {
          this.$notyf.error(xhr?.responseJSON?.message || 'Failed to revoke access.');
          this.revoking_user_id = null;
        },
      });
    },

    fetch_available_users() {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/get_available_users/';
      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }
      this.loading_users = true;
      this.users_error = null;

      $.ajax({
        url: url,
        method: "GET",
        headers: {
          "Authorization": `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: (response) => {
          const response_data = typeof response === "string" ? JSON.parse(response) : response;
          if (response_data.status === "success") {
            this.available_users = response_data.data
              .filter(user => user.id !== this.current_user_id)
              .map(user => ({
                id: user.id,
                name: user.name || user.full_name || `${user.first_name} ${user.last_name}`.trim() || user.email,
                email: user.email,
                role: user.role_name || user.role || 'User'
              }));
            this.filtered_available_users = [...this.available_users];
          } else {
            this.users_error = response_data.message || "Failed to load users";
          }
          this.loading_users = false;
        },
        error: (xhr, status, error) => {
          console.error("Error fetching users:", xhr.responseText || error);
          this.users_error = "An error occurred while fetching users. Please try again.";
          this.loading_users = false;
        }
      });
    },

    fetch_user_access_levels() {
      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/list_link_access_levels/';

      $.ajax({
        url,
        method: "GET",
        headers: { "Authorization": `Token ${token}` },
        success: (response) => {
          const arr = Array.isArray(response) ? response : (response?.data || []);
          this.access_levels = arr;
        },
        error: (xhr) => {
          let err_msg = "Failed to load access levels."; // default message
          try {
            const response = JSON.parse(xhr.responseText);
            if (response && response.message) {
              err_msg = response.message;
            }
          } catch (e) {
            console.error("Failed to parse error response:", e);
          }
          console.error("Error fetching access levels:", xhr.responseText || err_msg);
          this.$notyf.error(err_msg);
        }
      });
    },

    filter_users() {
      const query = this.user_search_query.toLowerCase().trim();
      if (!query) {
        this.filtered_available_users = [...this.available_users];
        return;
      }

      this.filtered_available_users = this.available_users.filter(user =>
        user.name.toLowerCase().includes(query) ||
        user.email.toLowerCase().includes(query)
      );
    },

    toggle_user_selection(user) {
      const index = this.selected_share_users.findIndex(u => u.id === user.id);
      if (index > -1) {
        this.selected_share_users.splice(index, 1);
      } else {
        this.selected_share_users.push(user);
      }
    },

    is_user_selected(user_id) {
      return this.selected_share_users.some(u => u.id === user_id);
    },

    async handle_share_with_users() {
      if (this.selected_share_users.length === 0) {
        this.$notyf.info('Please select at least one user to share with.');
        return;
      }

      if (!this.user_access_level) {
        this.$notyf.info('Please select an access level.');
        return;
      }

      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }
      this.sharing_in_progress = true;
      this.share_error = null;

      const recipient_ids = this.selected_share_users.map(u => u.id);
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/share_with_users/';

      try {
        const rd = await this.ajax_json_request({
          url, method: "POST", token,
          payload: {
            drive_item_id: this.share_file.id,
            recipient_ids,
            access_level: this.user_access_level,
          },
        });

        if (rd.status !== "success") throw new Error(rd.message || 'Sharing failed.');

        const userCount = this.selected_share_users.length;
        const userNames = this.selected_share_users.map(u => u.name).join(', ');
        const item_noun = this.share_item_noun();
        const folder_note = this.share_file?.type === 'folder'
          ? ' All folder contents are now accessible to them.'
          : '';

        this.$notyf.success(
          `${item_noun.charAt(0).toUpperCase() + item_noun.slice(1)} "${this.share_file.name}" shared successfully with ${userCount} user(s): ${userNames}.${folder_note}`
        );

        this.selected_share_users = [];
        this.user_access_level = '';
        this.user_search_query = '';
        this.filtered_available_users = [...this.available_users];

        if (this.details_file && String(this.details_file.id) === String(this.share_file.id)) {
          this.load_details_shared_with(this.details_file);
        }

      } catch (error_info) {
        const xhr = error_info?.xhr;
        const raw_message = error_info?.message;
        console.error(`Error sharing ${this.share_item_noun()}:`, xhr?.responseText || raw_message || error_info);

        let errorMessage = raw_message || `An error occurred while sharing the ${this.share_item_noun()}.`;
        try {
          const errorData = JSON.parse(xhr?.responseText || '{}');
          errorMessage = errorData.message || errorMessage;
        } catch (e) {
          // Use the message we already have
        }

        this.share_error = errorMessage;
        this.$notyf.error(this.share_error);
      } finally {
        this.sharing_in_progress = false;
      }
    },

    close_all_dropdowns() {
      this.open_dropdown_id = null;
      this.open_submenu_id = null;
      this.open_menu_name = null;
    },

    share_via_link(file) {
      if (this.is_folder(file)) {
        this.$notyf.info('Share links are only available for files.');
        return;
      }

      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }
      this.share_file = file;
      this.share_link = "";            // reset old link
      this.selected_access_level = ""; // reset previous selection

      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/list_link_access_levels/';
      $.ajax({
        url: url,
        method: "GET",
        headers: {
          "Authorization": `Token ${token}`,
        },
        success: (response) => {
          this.access_levels = response;
          this.open_share_modal();
        },
        error: (xhr, status, error) => {
          console.error("Error fetching access levels:", xhr.responseText || error);
          this.$notyf.error(xhr.responseText || " test Failed to load access levels.");
        }
      });
    },

    async generate_share_link() {
      if (this.is_folder(this.share_file)) {
        this.share_mode = 'restricted';
        this.$notyf.info('Share links are only available for files.');
        return;
      }

      if (!this.selected_access_level) {
        this.$notyf.info("Please select an access level.");
        return;
      }

      const token = get_token();
      const user_id = localStorage.getItem('user_id');
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/assign_share_link_access/';

      try {
        const rd = await this.ajax_json_request({
          url, method: "POST", token,
          payload: { user_id, link_access_level_id: this.selected_access_level, drive_item_id: this.share_file.id },
        });
        if (rd.status !== "success") throw new Error(rd.message || 'Failed to generate link.');
        this.share_link = rd?.data?.share_url || '';
        this.$notyf.success(`${this.share_item_label} share link generated!`);
      } catch (error_info) {
        const xhr = error_info?.xhr;
        const raw_message = error_info?.message;
        console.error("Error generating share link:", xhr?.responseText || raw_message || error_info);

        let errorMessage = raw_message || `An error occurred while generating the ${this.share_item_noun()} share link.`;
        try {
          const errorData = JSON.parse(xhr?.responseText || '{}');
          errorMessage = errorData.message || errorMessage;
        } catch (e) {
          // Keep existing message
        }

        this.$notyf.error(errorMessage);
      }
    },

    copy_share_link() {
      navigator.clipboard.writeText(this.share_link)
        .then(() => {
        this.$notyf.success("Link copied to clipboard!");
      })
      .catch(() => {
        this.$notyf.error("Failed to copy link.");
      });
    },

    is_office_file_for_open(file) {
      if (!file || file.type === "folder") {
        return false;
      }

      const ext = this.ext_of(file.name);
      if (["html", "htm"].includes(ext)) return false;

      return [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "xlsm",
        "xlsb",
        "ppt",
        "pptx",
        "odt",
        "ods",
        "odp",
        "csv",
      ].includes(ext);
    },


    preview_file(file) {
      this.close_all_dropdowns();

      if (this.is_office_file_for_open(file)) {
        this.open_in_office(file);
        return;
      }

      const token = get_token();
      if (!token) {
        this.$router.push({ name: "Login" });
        return;
      }

      const url = process.env.VUE_APP_API_BASE_URL + "/aic_one_api/aic_drive/preview_file/";

      $.ajax({
        url: url,
        method: "GET",
        data: { drive_item_id: file.id },
        headers: {
          Authorization: `Token ${token}`,
        },
        success: (response) => {
          const response_data =
            typeof response === "string" ? JSON.parse(response) : response;

          if (response_data.status === "success") {
            const { file_name, file_url } = response_data.data;

            this.selected_preview_file = file;
            this.preview_file_name = file_name;
            this.preview_file_url = file_url;
            this.preview_file_access_level = file.shared_access_level || null;
            this.preview_modal = true;
          } else {
            this.$notyf.error("Failed to load file preview.");
          }
        },
        error: (xhr, status, error) => {
          console.error("Error previewing file:", xhr.responseText || error);
          this.$notyf.error("An error occurred while previewing the file.");
        },
      });
    },

    close_the_file_preview(){
      this.preview_modal = false
      this.preview_file_url = null
    },

    // Drag and drop handlers
    handle_drag_start(event, file) {
      // Only allow dragging files, not folders (or allow folders too if you want)
      this.dragged_item = file;
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/html', event.target);

      // Add dragging class
      event.target.classList.add('dragging');
    },

    handle_drag_end(event) {
      event.target.classList.remove('dragging');
      this.dragged_item = null;
      this.drag_over_folder_id = null;
      this.page_drag_active = false;
    },

    handle_drag_over(event, folder) {
      // Only allow drop on folders
      if (folder.type !== 'folder') return;
      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';
      this.drag_over_folder_id = folder.id;
    },

    handle_drag_leave(folder) {
      if (folder.type !== 'folder') return;
      this.drag_over_folder_id = null;
    },

    handle_drop_on_folder(event, target_folder) {
      event.preventDefault();
      event.stopPropagation();
      this.drag_over_folder_id = null;
      this.page_drag_active = false;
      if (!this.dragged_item) return;

      // 1. Validation: Prevent dropping any item onto itself
      if (this.dragged_item.id === target_folder.id) {
        return;
      }

      // 2. Validation: Prevent dropping a folder into a file
      if (target_folder.type !== 'folder') {
        return;
      }

      // 3. Validation: Specifically for folders - prevent dropping into itself
      if (this.dragged_item.type === 'folder' && target_folder.name === this.dragged_item.name) {
        this.$notyf.error("You cannot move a folder into itself.");
        return;
      }

      // Proceed with move
      this.move_item_to_folder(this.dragged_item, target_folder);
    },

    move_item_to_folder(item, target_folder) {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/move_item/';
      const token = get_token();

      const payload = {
        item_id: item.id,
        target_folder_id: target_folder.id,
        target_folder_name: target_folder.name
      };

      $.ajax({
        url: url,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(payload),
        headers: {
          'Authorization': `Token ${token}`,
          'X-Page-URL': window.location.href,
        },
        success: () => {
          this.$notyf.success(`Moved to ${target_folder.name}`);
          const item_index = this.drive_items.findIndex(i => i.id === item.id);

          if (item_index !== -1) {
            const current_item = Reflect.get(this.drive_items, item_index);
            const updated_item = Object.assign({}, current_item);
            Reflect.set(updated_item, 'parent_id', target_folder.name);
            Reflect.set(updated_item, 'parent_folder_id', target_folder.id);
            this.drive_items.splice(item_index, 1, updated_item);
            if (String(target_folder.id ?? "") !== String(this.current_folder_id ?? "")) {
              this.remove_local_drive_item(item.id);
            }
          }
        },
        error: () => {
            this.$notyf.error("Failed to move item.");
        }
      });
    },

    handle_drop_on_path(event, target_folder) {
      event.preventDefault();
      event.stopPropagation();
      this.drag_over_folder_id = null;
      this.page_drag_active = false;

      if (!this.dragged_item) return;

      // 1. Check if the target is the root
      if (target_folder === null) {
        this.$notyf.info("Moving files to the default 'My Drive' folder is not allowed. Please select a specific folder.");
        return; // Stop the execution here
      }

      const target_name = target_folder.name;
      const target_id = target_folder.id;

      // 2. Standard check: Don't move if it's already in the target folder
      if (
        String(this.dragged_item.parent_folder_id || "") === String(target_id) ||
        (!this.dragged_item.parent_folder_id && this.dragged_item.parent_id === target_name)
      ) {
        return;
      }

      // 3. Proceed with move if it's a subfolder
      this.move_item_to_folder(this.dragged_item, {
        id: target_id,
        name: target_name
      });
    },

    handle_drop_on_root() {
      // Check if there is an item currently being dragged
      if (!this.dragged_item) return;

      // Create a mock target for the root directory
      const root_target = {
        id: null, // or your specific root ID if applicable
        name: "My Drive"
      };

      // Reuse your existing move logic
      this.move_item_to_folder(this.dragged_item, root_target);
    },

     // Libre Office Online integration
    can_open_in_office(file) {
       // Only files, not folders
      if (!file || file.type === "folder") return false;
      // Must be editable (owner OR shared as Editor)
      if (!this.can_edit(file)) return false;
      // Only office formats you actually want to send to Collabora/WOPI
      const ext = this.ext_of(file.name);
      if (["html", "htm"].includes(ext)) return false;
      const supported = [
        "doc", "docx", "odt",
        "xls", "xlsx", "ods",
        "ppt", "pptx", "odp",
        "txt", "csv"
      ];

      return supported.includes(ext);
    },

    open_in_office(file) {
      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }
      this.close_all_dropdowns();

      const drive_item_id = file.id;
      const editor_lock_key = `editor_open_${drive_item_id}`;
      const editor_tab_name = `aic_drive_editor_${drive_item_id}`;
      if (!this.acquire_editor_lock(editor_lock_key)) return;

      const url = process.env.VUE_APP_API_BASE_URL + "/aic_one_api/aic_drive/api/open_in_editor_api/";

      $.ajax({
        url: url,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({ drive_item_id: drive_item_id }),
        headers: {
          "Authorization": `Token ${token}`,
          "X-Page-URL": window.location.href,
        },
        success: (response) => {
           const res = typeof response === "string" ? JSON.parse(response) : response;
          const editor_url = res?.editor_url || res?.data?.editor_url;
          if (!editor_url) {
            this.$notyf.error("Editor URL was not returned by server.");
            this.release_editor_lock(editor_lock_key);
            return;
          }
          this.track_file_open(drive_item_id);
          if (!this.open_editor_tab(editor_url, editor_tab_name)) {
            this.release_editor_lock(editor_lock_key);
          }
        },
        error: (xhr) => {
          this.release_editor_lock(editor_lock_key);
          if (xhr.status === 403) {
            this.$notyf.error("You do not have edit permission for this file.");
            return;
          }
          if (xhr.status === 401) {
            this.$router.push({ name: "Login" });
            return;
          }
          this.$notyf.error(xhr?.responseJSON?.message || `Failed to open editor: HTTP ${xhr.status}`);
        },
      });
    },

    _refresh_after_editor_return() {
      if (this._office_focus_handler) {
        window.removeEventListener("focus", this._office_focus_handler);
      }

      // Refresh once when user returns to this browser tab
      this._office_focus_handler = async () => {
        window.removeEventListener("focus", this._office_focus_handler);
        this._office_focus_handler = null;
        await this.fetch_drive_items();
        this.apply_local_timestamps();
      };
      window.addEventListener("focus", this._office_focus_handler);
    },

    open_rename_modal(file) {
      this.rename_item = file;
      const last_dot = file.name.lastIndexOf('.');
      this.rename_new_name = last_dot > 0 ? file.name.slice(0, last_dot) : file.name;
      this.rename_in_progress = false;
      this.close_all_dropdowns();
      this.close_mobile_action_menu();
      this.$nextTick(() => {
        this.show_modal('rename_item_modal');
        setTimeout(() => {
          const input = document.getElementById('rename_item_modal')?.querySelector('input');
          if (input) { input.focus(); input.select(); }
        }, 200);
      });
    },

    confirm_rename() {
      const new_name = (this.rename_new_name || '').trim();
      if (!new_name) { this.$notyf.info('Please enter a name.'); return; }
      if (!this.rename_item) return;

      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }

      const ext = this.ext_of(this.rename_item.name);
      const full_name = ext ? `${new_name}.${ext}` : new_name;
      if (full_name.trim().toLowerCase() === (this.rename_item.name || '').trim().toLowerCase()) {
        this.$notyf.info('No changes made. Enter a different name.');
        return;
      }
      this.rename_in_progress = true;

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/rename_drive_item/`;

      $.ajax({
        url, method: 'POST', contentType: 'application/json',
        data: JSON.stringify({ item_id: this.rename_item.id, name: full_name }),
        headers: { 'Authorization': `Token ${token}`, 'X-Page-URL': window.location.href },
        success: (response) => {
          const rd = typeof response === 'string' ? JSON.parse(response) : response;
          if (rd.status === 'success') {
            const renamed_item_id = this.rename_item.id;
            const renamed_item_name = rd.data.name;
            this.$notyf.success(`Renamed to "${rd.data.name}"`);
            this.hide_modal('rename_item_modal');
            this.drive_items = this.drive_items.map((item) => (
              item.id === renamed_item_id ? { ...item, name: renamed_item_name } : item
            ));
            this.apply_local_timestamps();
          } else {
            this.$notyf.error(rd.message || 'Failed to rename.');
          }
          this.rename_in_progress = false;
        },
        error: (xhr) => {
          if (xhr.status === 401) this.$router.push({ name: 'Login' });
          else this.$notyf.error(xhr?.responseJSON?.message || `Error: HTTP ${xhr.status}`);
          this.rename_in_progress = false;
        },
      });
    },

    async open_delete_confirm(file) {
      this.delete_item = file;
      this.delete_in_progress = false;
      this.close_all_dropdowns();
      this.close_mobile_action_menu();

      const is_folder = file?.type === 'folder';
      const is_trashed = this.is_trashed_item(file);
      const result = await Swal.fire({
        title: is_trashed ? 'Delete forever?' : 'Move to trash?',
        text: is_trashed
          ? (is_folder
            ? 'This folder and all files and subfolders inside it will be permanently deleted.'
            : 'This file will be permanently deleted.')
          : (is_folder
            ? 'This folder and its contents will be moved to Trash.'
            : 'This file will be moved to Trash.'),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        showConfirmButton: true,
        confirmButtonText: is_trashed ? 'Delete forever' : 'Move to trash',
      });

      if (!result.isConfirmed) {
        this.delete_item = null;
        return;
      }

      this.confirm_delete();
    },

    confirm_delete() {
      if (!this.delete_item) return;
      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }
      this.delete_in_progress = true;
      const is_trashed = this.is_trashed_item(this.delete_item);
      const endpoint = is_trashed ? 'delete_drive_item' : 'trash_drive_item';
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/${endpoint}/`;
      $.ajax({
        url, method: 'POST', contentType: 'application/json',
        data: JSON.stringify({ item_id: this.delete_item.id, drive_item_id: this.delete_item.id }),
        headers: { 'Authorization': `Token ${token}`, 'X-Page-URL': window.location.href },
        success: (response) => {
          const rd = typeof response === 'string' ? JSON.parse(response) : response;
          if (!rd.status || rd.status === 'success') {
            this.$notyf.success(rd.message || (is_trashed ? 'Deleted forever.' : 'Moved to Trash.'));
            if (is_trashed || this.drive_section !== "trash") {
              this.drive_items = this.drive_items.filter(i => i.id !== this.delete_item.id);
            } else {
              this.drive_items = this.drive_items.map((item) => (
                item.id === this.delete_item.id ? { ...item, is_trashed: true } : item
              ));
            }
            this.delete_item = null;
            if (is_trashed) this.fetch_storage_stats();
          } else {
            this.$notyf.error(rd.message || (is_trashed ? 'Failed to delete.' : 'Failed to move to Trash.'));
          }
          this.delete_in_progress = false;
        },
        error: (xhr) => {
          if (xhr.status === 401) this.$router.push({ name: 'Login' });
          else this.$notyf.error(xhr?.responseJSON?.message || `Error: HTTP ${xhr.status}`);
          this.delete_in_progress = false;
        },
      });
    },

    async empty_trash() {
      const items_to_delete = this.trash_items;
      if (!items_to_delete.length) {
        this.$notyf.info('Trash is already empty.');
        return;
      }

      const result = await Swal.fire({
        title: 'Empty trash?',
        text: `This will permanently delete ${items_to_delete.length} item${items_to_delete.length === 1 ? '' : 's'} from Trash.`,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        showConfirmButton: true,
        confirmButtonText: 'Empty trash',
      });

      if (!result.isConfirmed) return;

      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }

      this.empty_trash_in_progress = true;
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/delete_drive_item/`;

      try {
        const delete_results = await Promise.allSettled(
          items_to_delete.map((item) => this.ajax_json_request({
            url,
            method: 'POST',
            token,
            payload: { item_id: item.id, drive_item_id: item.id },
          })),
        );
        const deleted_ids = items_to_delete
          .filter((item, index) => {
            const delete_result = Reflect.get(delete_results, index);
            const response = delete_result?.value;

            return (
              delete_result?.status === 'fulfilled' &&
              (!response?.status || response.status === 'success')
            );
          })
          .map((item) => item.id);
        const failed_count = items_to_delete.length - deleted_ids.length;

        if (failed_count) {
          this.$notyf.error(`${failed_count} item${failed_count === 1 ? '' : 's'} could not be deleted.`);
        } else {
          this.$notyf.success('Trash emptied.');
        }

        this.drive_items = this.drive_items.filter((item) => !deleted_ids.includes(item.id));
        this.fetch_storage_stats();
      } catch {
        this.$notyf.error('Failed to empty trash.');
      } finally {
        this.empty_trash_in_progress = false;
      }
    },

    build_drive_item_action_payload(file) {
      return ({ item_id: file.id, drive_item_id: file.id });
    },

    post_drive_item_action(endpoint, file, token) {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/${endpoint}/`;
      return this.ajax_json_request({
        url,
        method: "POST",
        token,
        payload: this.build_drive_item_action_payload(file),
      });
    },

    assert_success_response(response_data, fallback_message) {
      if (!this.is_success_response(response_data)) {
        throw new Error(response_data.message || fallback_message);
      }
    },

    handle_restore_drive_item_success(file, response_data) {
      this.$notyf.success(response_data.message || `Restored "${file.name}".`);
      this.remove_local_drive_item(file.id);
    },

    notify_drive_action_error(error_info, fallback_message) {
      const xhr = error_info?.xhr;
      this.$notyf.error(xhr?.responseJSON?.message || error_info?.message || fallback_message);
    },

    async restore_drive_item(file) {
      const token = this.get_authenticated_token();
      if (!token) return;

      this.close_all_dropdowns();
      this.close_mobile_action_menu();

      try {
        const rd = await this.post_drive_item_action("restore_drive_item", file, token);
        this.assert_success_response(rd, "Failed to restore item.");
        this.handle_restore_drive_item_success(file, rd);
      } catch (error_info) {
        this.notify_drive_action_error(error_info, "Failed to restore item.");
      }
    },

    copy_file(file) {
      if (!this.can_copy_file(file)) return;

      this.copied_file = this.build_copied_file_payload(file);
      this.persist_copied_file();
      this.close_all_dropdowns();
      this.close_mobile_action_menu();
      this.$notyf.success('File copied. Open a folder and click Paste.');
    },

    ensure_copied_file_selected() {
      if (!this.has_copied_file) {
        this.$notyf.info('No file selected to paste.');
        return false;
      }

      return true;
    },

    build_paste_file_payload() {
      return ({
        drive_item_id: this.copied_file.id,
        target_folder_id: this.current_folder_id ?? null,
      });
    },

    async handle_paste_file_success(response_data) {
      this.assert_success_response(response_data, response_data.detail || 'Failed to copy file.');

      await Swal.fire({
        icon: 'success',
        title: 'File pasted',
        text: response_data.message || `"${this.copied_file.name}" was copied successfully.`,
        confirmButtonText: 'OK',
      });
      this.upsert_local_drive_item(this.response_drive_item(response_data), {
        name: this.copied_file.name,
        type: "file",
        item_type: "file",
        extension: this.ext_of(this.copied_file.name),
      });
    },

    async show_paste_file_error(error_info) {
      const xhr = error_info?.xhr;
      const error_message = xhr?.responseJSON?.message
        || xhr?.responseJSON?.detail
        || error_info?.message
        || 'Failed to paste file.';

      await Swal.fire({
        icon: 'error',
        title: 'Paste failed',
        text: error_message,
        confirmButtonText: 'OK',
      });
    },

    async paste_copied_file() {
      if (!this.ensure_copied_file_selected()) return;

      const token = this.get_authenticated_token();
      if (!token) return;

      try {
        const url = `${process.env.VUE_APP_API_BASE_URL}${COPY_FILE_URL}`;
        const response_data = await this.ajax_json_request({
          url,
          method: 'POST',
          token,
          payload: this.build_paste_file_payload(),
        });

        await this.handle_paste_file_success(response_data);
      } catch (error_info) {
        await this.show_paste_file_error(error_info);
      }
    },

    fetch_admin_drives() {
      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }

      const should_show_loader = this.admin_drives.length === 0;
      if (should_show_loader) this.admin_drives_loading = true;

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/get_all_drives/`;

      $.ajax({
        url,
        method: "GET",
        headers: {
          "Authorization": `Token ${token}`,
          "X-Page-URL": window.location.href,
        },
        success: (response) => {
          const rd = typeof response === "string" ? JSON.parse(response) : response;
          if (rd.status === "success") {
            this.admin_drives = rd.data || [];

            if (this.admin_selected_drive) {
              const refreshed = this.admin_drives.find(d => d.id === this.admin_selected_drive.id);
              if (refreshed) {
                this.admin_selected_drive = refreshed;
                const items = (refreshed.items || []).map(item => this.normalize_drive_item(item));
                items.sort((a, b) => {
                  if (a.type === b.type) return Number(b.updated_ts || 0) - Number(a.updated_ts || 0);
                  return a.type === "folder" ? -1 : 1;
                });
                this.drive_items = items;
                this.apply_local_timestamps();
              }
            }

          } else {
            this.$notyf.error(rd.message || "Failed to load drives.");
          }
        },
        error: (xhr) => {
          if (xhr.status === 401) this.$router.push({ name: "Login" });
          else if (xhr.status === 403) this.$notyf.error("You don't have permission to view all drives.");
          else this.$notyf.error("Failed to load drives.");
        },
        complete: () => {
          if (should_show_loader) this.admin_drives_loading = false;
        },
      });
    },

    open_admin_drive(drive) {
      this.admin_selected_drive = drive;
      this.current_folder = drive.name;
      this.current_folder_id = null;
      this.current_drive_id = drive.id;

      const items = (drive.items || []).map(item => this.normalize_drive_item(item));
      items.sort((a, b) => {
        if (a.type === b.type) return Number(b.updated_ts || 0) - Number(a.updated_ts || 0);
        return a.type === "folder" ? -1 : 1;
      });
      this.drive_items = items;
      this.apply_local_timestamps();
    },

    can_transfer_ownership(file) {
      return (
        file &&
        !this.is_trashed_item(file) &&
        this.can_manage_file(file)
      );
    },

    open_transfer_ownership_modal(file) {
      this.transfer_item = file;
      this.transfer_target_user_id = null;
      this.transfer_user_query = '';
      this.transfer_in_progress = false;

      if (!this.available_users.length) {
        this.fetch_available_users();
      }

      this.filtered_transfer_users = this.available_users.filter(
        (u) => u.id !== this.current_user_id
      );

      this.$nextTick(() => this.show_modal('transfer_ownership_modal'));
    },

    filter_transfer_users() {
      const q = (this.transfer_user_query || '').toLowerCase().trim();
      const candidates = this.available_users.filter(
        (u) => u.id !== this.current_user_id
      );

      this.filtered_transfer_users = q
        ? candidates.filter(
            (u) =>
              u.name.toLowerCase().includes(q) ||
              u.email.toLowerCase().includes(q)
          )
        : candidates;
    },

    can_confirm_transfer_ownership() {
      return Boolean(this.transfer_item && this.transfer_target_user_id);
    },

    build_transfer_ownership_payload() {
      return ({
        drive_item_id: this.transfer_item.id,
        new_owner_id: this.transfer_target_user_id,
      });
    },

    handle_transfer_ownership_success(response_data) {
      this.assert_success_response(response_data, 'Transfer failed.');
      this.$notyf.success(response_data.message || 'Ownership transferred successfully.');
      this.hide_modal('transfer_ownership_modal');

      // The item now lives in someone else's drive; remove it from the local list.
      this.remove_local_drive_item(this.transfer_item.id);
    },

    handle_transfer_ownership_error(error_info) {
      const xhr = error_info?.xhr;
      this.$notyf.error(
        xhr?.responseJSON?.message ||
        error_info?.message ||
        'Failed to transfer ownership.'
      );
    },

    async confirm_transfer_ownership() {
      if (!this.can_confirm_transfer_ownership()) return;

      const token = this.get_authenticated_token();
      if (!token) return;

      this.transfer_in_progress = true;

      try {
        const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/transfer_ownership/`;
        const rd = await this.ajax_json_request({
          url,
          method: 'POST',
          token,
          payload: this.build_transfer_ownership_payload(),
        });

        this.handle_transfer_ownership_success(rd);
      } catch (error_info) {
        this.handle_transfer_ownership_error(error_info);
      } finally {
        this.transfer_in_progress = false;
      }
    },

  }
};
